import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, Pipe, ViewEncapsulation, ViewChild, EventEmitter, Output, NgModule } from '@angular/core';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i2 from 'web-storage';
import * as Roles from 'app-models';
import { WorkDetailsLib, acceptedFileTypes, acceptedFileTypesText } from 'app-models';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import * as moment from 'moment';
import moment__default from 'moment';
import * as i13 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from 'environment-configurations';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i10 from 'dirty-check-store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import * as i2$1 from '@ngrx/store';
import { takeUntil, take, map as map$1 } from 'rxjs/operators';
import * as i24 from 'custom-questionnaire';
import { CustomQuestionnaireComponent, CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i1$2 from 'reference-library';
import * as i2$2 from 'ngx-toastr';
import * as i3$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i5$1 from 'cache-country-list';
import * as i8 from 'app-services-library';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i12 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i14 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i15 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i16 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i17 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i18 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i19 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i20 from 'primeng/api';
import * as i21 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i22 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i23 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i25 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i26 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i29 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i30 from 'file-upload-deafult-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import { saveAs } from 'file-saver';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import * as i10$1 from 'file-download-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { PrimengLibraryModule } from 'primeng-library';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { SaveAsDraftModule } from 'save-as-draft';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i7 from 'angular-file';
import { ngfModule } from 'angular-file';

class GenericBeneficiaryWorkExperienceService {
    constructor(http, webStorage) {
        this.http = http;
        this.webStorage = webStorage;
        this.isExpired = false;
        this.statusChangeSubScriptionSubjectStep = new BehaviorSubject(1);
        this.formIsDirtySubject = new BehaviorSubject({ dirty: false, formName: '', formNumber: 1 });
        this.deletedfile$ = new BehaviorSubject({});
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
        this.uploaded$ = new BehaviorSubject({});
        this.dependentProfileSubject = new BehaviorSubject({});
        this.onLifeStorySubTabs = new Subject();
        this.isExperienceChanged = new Subject();
        this.currentUserSubject = new BehaviorSubject(this.webStorage.getWebStorageItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    getBeneficiaryDetails(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/${type}${profileFamilyString}`).pipe(map((response) => response.data));
    }
    saveBeneficiaryDetails(beneficiaryId, type, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/beneficiary/${beneficiaryId}/profile/${type}${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    getStates(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    deleteBeneExperience(beneficiaryId, experienceId, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.delete(`/beneficiary/${beneficiaryId}/profile/experience/${experienceId}${profileFamilyString}`).pipe(map((data) => {
            // IM-3066 - remove deleted file.
            this.deletefile(beneficiaryId);
            return data;
        }));
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    deletBeneWorkExperience(visaType, caseType, caseId, type, superTaskId, subTaskId, experienceId) {
        return this.http.delete(`/${visaType}/${caseType}/${caseId}/${type}/${experienceId}?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deletBeneGCWorkExperience(visaType, caseType, caseId, type, superTaskId, subTaskId, experienceId) {
        let _caseType = caseType == 'I140' ? 'i140Case' : 'Perm';
        return this.http.delete(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/${_caseType}/workExperienceDetails/${experienceId}/delete`, {}).pipe(
        //return this.http.delete(`/${visaType}/${caseType}/${caseId}/experience/${experienceId}?superTaskId=${superTaskId}&taskId=${subTaskId}`, {}).pipe(
        map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getCountry() {
        return this.http.get('/countries').pipe(map((response) => {
            if (response.data) {
                this.countryDataSource.next({ listCountries: response.data });
                return response.data;
            }
        }));
    }
    getCachedCountryList() {
        return this.countryDataSource.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    checkBeneEditPermission() {
        const permission = JSON.parse(sessionStorage.getItem('currentUser'));
        return permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
        // return permission['permissions'].length>0 && permission['permissions'].find(x=> x === 'DELETE_BENEFICIARY')? true : false;
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    checkValidity() {
        return this.isExpired; /////
    }
    experienceChanged(data) {
        this.isExperienceChanged.next(data);
    }
    onUnSubscribe(subcriptions) {
        subcriptions.forEach(subcription => {
            if (subcription) {
                subcription.unsubscribe();
            }
        });
    }
    getBeneExperienceInformation(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForBenEdit, familyId) {
        let url = `/${visatype}/${caseType}/${caseId}/${this.toEncrypt(synctype)}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}`;
        if (caseType === 'I485') {
            const strFamilyId = familyId ? `&familyId=${familyId}` : '';
            url = `/GCFLY/I485/${caseId}/${this.toEncrypt('experience')}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}${strFamilyId}`;
        }
        return this.http.get(url).pipe(map((response) => {
            return response.data;
        }));
    }
    savePetitionWorkExperience(petitionId, payload, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/petition/saveExperience/${petitionId}${profileFamilyString}`, payload).pipe(map((response) => response));
    }
    savePetitionGCWorkExperience(caseId, type, payload) {
        return this.http.post(`/gcCase/saveExperience/${caseId}/${this.toEncrypt(type)}`, payload).pipe(map((response) => response));
    }
    getBeneGCExperienceInformation(visatype, caseType, caseId, synctype, superTaskId, subTaskId, isUsedForBenEdit) {
        let _caseType = caseType == 'I140' ? 'i140Case' : 'Perm';
        return this.http.get(`/superTask/${superTaskId}/subTask/${subTaskId}/gc/${_caseType}/workExperienceDetails?isUsedForBenEdit=${isUsedForBenEdit}`).pipe(
        //return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}`).pipe(
        map((response) => {
            return response.data.gcWorkExperienceDetailsResponseList;
        }));
    }
    onGetWorkExperienceDetailsPerm(gcPermCaseId, isUsedForBenEdit = null) {
        return this.http.get(`/gc/perm/${gcPermCaseId}/workExperienceDetails${isUsedForBenEdit != null ? '?isUsedForBenEdit=' + isUsedForBenEdit : ''}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data.gcWorkExperienceDetailsResponseList;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
GenericBeneficiaryWorkExperienceService.ɵfac = function GenericBeneficiaryWorkExperienceService_Factory(t) { return new (t || GenericBeneficiaryWorkExperienceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ImagilityWebStorage)); };
GenericBeneficiaryWorkExperienceService.ɵprov = i0.ɵɵdefineInjectable({ token: GenericBeneficiaryWorkExperienceService, factory: GenericBeneficiaryWorkExperienceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryWorkExperienceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ImagilityWebStorage }]; }, null); })();

class ConfirmationModalComponent$1 {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent$1.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent$1)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2$1.Store)); };
ConfirmationModalComponent$1.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent$1, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["mat-button", "", 1, "btnCustom", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent$1, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2$1.Store }]; }, null); })();

class DependentProfileDataService {
    constructor() {
        this.dependentProfileSubject = new BehaviorSubject({});
        this.onLifeStorySubTabs = new Subject();
        this.selfBeneficiaryDetailChange = new Subject();
        this.newSubDependentCreated = new Subject();
    }
    changeDependentProfileID(dependentId, beneficiaryType) {
        this.dependentProfileSubject.next({ dependentId: dependentId, beneficiaryType: beneficiaryType });
    }
}
DependentProfileDataService.ɵfac = function DependentProfileDataService_Factory(t) { return new (t || DependentProfileDataService)(); };
DependentProfileDataService.ɵprov = i0.ɵɵdefineInjectable({ token: DependentProfileDataService, factory: DependentProfileDataService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DependentProfileDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

//IM-2472 - Download button opens file instead of download
function FileDownloadComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵlistener("click", function FileDownloadComponent_a_0_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.download(); });
    i0.ɵɵelementStart(1, "mat-icon", 2);
    i0.ɵɵtext(2, "get_app");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class FileDownloadComponent {
    constructor(http) {
        this.http = http;
    }
    ngOnInit() {
    }
    download() {
        this.http.get(this.Path, { responseType: "arraybuffer" }).subscribe(pdf => {
            var blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, this.fileName);
        });
    }
}
FileDownloadComponent.ɵfac = function FileDownloadComponent_Factory(t) { return new (t || FileDownloadComponent)(i0.ɵɵdirectiveInject(i1.HttpClient)); };
FileDownloadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FileDownloadComponent, selectors: [["app-file-download"]], inputs: { fileName: "fileName", Path: "Path" }, decls: 1, vars: 1, consts: [[3, "click", 4, "ngIf"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Download Document", 1, "material-icons"]], template: function FileDownloadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FileDownloadComponent_a_0_Template, 3, 0, "a", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.fileName);
    } }, directives: [i5.NgIf, i3.MatIcon, i4.MatTooltip], styles: ["a[_ngcontent-%COMP%]{color:#505050;text-decoration:none;background-color:transparent}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadComponent, [{
        type: Component,
        args: [{
                selector: 'app-file-download',
                templateUrl: './file-download.component.html',
                styleUrls: ['./file-download.component.scss']
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, { fileName: [{
            type: Input
        }], Path: [{
            type: Input
        }] }); })();

class ImgDateFormatPipe {
    transform(value) {
        return (value ? moment(value).format('MM/DD/YYYY') : '');
    }
}
ImgDateFormatPipe.ɵfac = function ImgDateFormatPipe_Factory(t) { return new (t || ImgDateFormatPipe)(); };
ImgDateFormatPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "ImgDateFormat", type: ImgDateFormatPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgDateFormatPipe, [{
        type: Pipe,
        args: [{ name: 'ImgDateFormat' }]
    }], null, null); })();

const _c0$1 = ["item"];
const _c1$1 = ["benExpForm"];
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(4); ctx_r11.handleShowTabs(); ctx_r11.resetFormToInitial(ctx_r11.benExpForm); return ctx_r11.formCheck(ctx_r11.benExpForm["form"], ctx_r11.clientForm, ctx_r11.dutiesForm, ctx_r11.toolsAndTech); });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2, " Add Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵtext(1, "Employment");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵelementStart(1, "div", 60);
    i0.ɵɵelementStart(2, "mat-checkbox", 61);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_3_Template_mat_checkbox_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(7); return ctx_r54.beneficiaryWorkDetails.isCurrentRole = $event; });
    i0.ɵɵelementStart(3, "span", 62);
    i0.ɵɵtext(4, " I am currently working in this role");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r28.beneficiaryWorkDetails.isCurrentRole);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "label", 64);
    i0.ɵɵtext(2, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 65, 66);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_5_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(7); return ctx_r57.beneficiaryWorkDetails.designation = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r29.beneficiaryWorkDetails.designation);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "label", 64);
    i0.ɵɵtext(2, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 65, 66);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_6_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(7); return ctx_r60.beneficiaryWorkDetails.designation = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r30.beneficiaryWorkDetails.designation);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_7_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 72);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r64 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(type_r64.name);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 68);
    i0.ɵɵtext(2, "Employment Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 69, 70);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_7_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r66); i0.ɵɵnextContext(); const _r27 = i0.ɵɵreference(2); const ctx_r65 = i0.ɵɵnextContext(6); return ctx_r65.handleEmploymentTypeChange(ctx_r65.beneficiaryWorkDetails.employmentType, _r27); })("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_7_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(7); return ctx_r67.beneficiaryWorkDetails.employmentType = $event; });
    i0.ɵɵtemplate(5, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_7_ng_template_5_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r31.listEmploymentType)("ngModel", ctx_r31.beneficiaryWorkDetails.employmentType);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_8_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r70 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(type_r70.name);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 68);
    i0.ɵɵtext(2, "Employment Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 69, 70);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_8_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r72); i0.ɵɵnextContext(); const _r27 = i0.ɵɵreference(2); const ctx_r71 = i0.ɵɵnextContext(6); return ctx_r71.handleEmploymentTypeChange(ctx_r71.beneficiaryWorkDetails.employmentType, _r27); })("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_8_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r72); const ctx_r73 = i0.ɵɵnextContext(7); return ctx_r73.beneficiaryWorkDetails.employmentType = $event; });
    i0.ɵɵtemplate(5, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_8_ng_template_5_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r32.listEmploymentType)("ngModel", ctx_r32.beneficiaryWorkDetails.employmentType);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 74);
    i0.ɵɵtext(2, "Employed From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 75);
    i0.ɵɵelementStart(4, "input", 76, 77);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_10_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(7); return ctx_r76.beneficiaryWorkDetails.startDate = $event; })("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_10_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r77); const _r75 = i0.ɵɵreference(8); return _r75.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 78);
    i0.ɵɵelement(7, "mat-datepicker", null, 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r75 = i0.ɵɵreference(8);
    const ctx_r33 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r75)("ngModel", ctx_r33.beneficiaryWorkDetails.startDate)("max", ctx_r33.maxDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r75);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 80);
    i0.ɵɵtext(2, "Employed From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 75);
    i0.ɵɵelementStart(4, "input", 76, 77);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_11_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(7); return ctx_r81.beneficiaryWorkDetails.startDate = $event; })("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_11_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r82); const _r80 = i0.ɵɵreference(8); return _r80.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 78);
    i0.ɵɵelement(7, "mat-datepicker", null, 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r80 = i0.ɵɵreference(8);
    const ctx_r34 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r80)("ngModel", ctx_r34.beneficiaryWorkDetails.startDate)("max", ctx_r34.maxDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r80);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 81);
    i0.ɵɵtext(2, "Employed Till");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 75);
    i0.ɵɵelementStart(4, "input", 82);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_12_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(7); return ctx_r85.beneficiaryWorkDetails.endDate = $event; })("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_12_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r86); const _r84 = i0.ɵɵreference(7); return _r84.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 78);
    i0.ɵɵelement(6, "mat-datepicker", null, 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r84 = i0.ɵɵreference(7);
    const ctx_r35 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r84)("ngModel", ctx_r35.beneficiaryWorkDetails.endDate)("min", ctx_r35.beneficiaryWorkDetails.startDate)("max", ctx_r35.maxDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r84);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 84);
    i0.ɵɵtext(2, "Employed Till");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 75);
    i0.ɵɵelementStart(4, "input", 82);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_13_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r90); const ctx_r89 = i0.ɵɵnextContext(7); return ctx_r89.beneficiaryWorkDetails.endDate = $event; })("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_13_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r90); const _r88 = i0.ɵɵreference(7); return _r88.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 78);
    i0.ɵɵelement(6, "mat-datepicker", null, 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r88 = i0.ɵɵreference(7);
    const ctx_r36 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("matDatepicker", _r88)("ngModel", ctx_r36.beneficiaryWorkDetails.endDate)("min", ctx_r36.beneficiaryWorkDetails.startDate)("max", ctx_r36.maxDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r88);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_14_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 89);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const currency_r95 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(currency_r95.name);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 85);
    i0.ɵɵtext(2, "Salary ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵelementStart(4, "p-dropdown", 86, 87);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_14_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r97); const ctx_r96 = i0.ɵɵnextContext(7); return ctx_r96.beneficiaryWorkDetails.currency = $event; });
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_14_ng_template_6_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "input", 88, 48);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_14_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r97); const ctx_r98 = i0.ɵɵnextContext(7); return ctx_r98.beneficiaryWorkDetails.salary = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r37.currencyTypeList)("ngModel", ctx_r37.beneficiaryWorkDetails.currency);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r37.beneficiaryWorkDetails.salary);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_h5_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 90);
    i0.ɵɵtext(1, "Employer Contact Details");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵelementStart(1, "label", 92);
    i0.ɵɵtext(2, "Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 93, 94);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_26_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r101); const ctx_r100 = i0.ɵɵnextContext(7); return ctx_r100.beneficiaryWorkDetails.companyName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r40.beneficiaryWorkDetails.companyName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵelementStart(1, "label", 95);
    i0.ɵɵtext(2, "Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 93, 94);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_27_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r104); const ctx_r103 = i0.ɵɵnextContext(7); return ctx_r103.beneficiaryWorkDetails.companyName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r41.beneficiaryWorkDetails.companyName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_28_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 101);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r106.getGlobalErrorMessages("INVALID_NUMBER"), " ");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_28_Template(rf, ctx) { if (rf & 1) {
    const _r108 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵelementStart(1, "label", 96);
    i0.ɵɵtext(2, "Office Phone Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵelementStart(4, "p-dropdown", 97);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_28_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r108); const ctx_r107 = i0.ɵɵnextContext(7); return ctx_r107.beneficiaryWorkDetails.officeCountryCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 98, 99);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_28_Template_input_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r108); const ctx_r109 = i0.ɵɵnextContext(7); return ctx_r109.beneficiaryWorkDetails.officeNo = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_28_span_7_Template, 2, 1, "span", 100);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r105 = i0.ɵɵreference(6);
    i0.ɵɵnextContext();
    const _r27 = i0.ɵɵreference(2);
    const ctx_r42 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r42.listCountryOfficePhone)("ngModel", ctx_r42.beneficiaryWorkDetails.officeCountryCode)("filter", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r42.beneficiaryWorkDetails.officeNo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (_r105.touched || _r27.submitted) && (_r105.errors == null ? null : _r105.errors.pattern));
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 63);
    i0.ɵɵelementStart(2, "label", 102);
    i0.ɵɵtext(3, "Address Line 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 103, 104);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_29_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(7); return ctx_r111.beneficiaryWorkDetails.addressLine1 = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r43.beneficiaryWorkDetails.addressLine1);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r115 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 63);
    i0.ɵɵelementStart(2, "label", 102);
    i0.ɵɵtext(3, "Address Line 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 105, 104);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_30_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r115); const ctx_r114 = i0.ɵɵnextContext(7); return ctx_r114.beneficiaryWorkDetails.addressLine1 = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r44.beneficiaryWorkDetails.addressLine1);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r117 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 63);
    i0.ɵɵelementStart(2, "label", 106);
    i0.ɵɵtext(3, "Address Line 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 107);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_31_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r117); const ctx_r116 = i0.ɵɵnextContext(7); return ctx_r116.beneficiaryWorkDetails.addressLine2 = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r45.beneficiaryWorkDetails.addressLine2);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 114);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r123 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(country_r123.countryName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_7_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const state_r126 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(state_r126.stateProvinceName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r128 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 115);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 116, 117);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_7_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r128); const ctx_r127 = i0.ɵɵnextContext(8); return ctx_r127.beneficiaryWorkDetails.stateProvinceCode = $event; });
    i0.ɵɵtemplate(5, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_7_ng_template_5_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r120 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r120.listStates)("ngModel", ctx_r120.beneficiaryWorkDetails.stateProvinceCode)("filter", true);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r131 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 119);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 120, 121);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_8_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r131); const ctx_r130 = i0.ɵɵnextContext(8); return ctx_r130.beneficiaryWorkDetails.stateProvinceName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r121 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r121.beneficiaryWorkDetails.stateProvinceName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r133 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 67);
    i0.ɵɵelementStart(2, "label", 108);
    i0.ɵɵtext(3, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 109, 110);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r133); const ctx_r132 = i0.ɵɵnextContext(7); return ctx_r132.handleCountryChange($event.value); })("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r133); const ctx_r134 = i0.ɵɵnextContext(7); return ctx_r134.beneficiaryWorkDetails.countryCode = $event; });
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_ng_template_6_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_7_Template, 6, 3, "div", 44);
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_div_8_Template, 5, 1, "div", 44);
    i0.ɵɵelementStart(9, "div", 67);
    i0.ɵɵelementStart(10, "label", 111);
    i0.ɵɵtext(11, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 112, 113);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r133); const ctx_r135 = i0.ɵɵnextContext(7); return ctx_r135.beneficiaryWorkDetails.city = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r46.listCountry)("ngModel", ctx_r46.beneficiaryWorkDetails.countryCode)("filter", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r46.listStates.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r46.listStates.length);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r46.beneficiaryWorkDetails.city);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 125);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r141 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(country_r141.countryName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_7_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const state_r144 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(state_r144.stateProvinceName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r146 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 126);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 127, 117);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_7_Template_p_dropdown_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r146); const ctx_r145 = i0.ɵɵnextContext(8); return ctx_r145.beneficiaryWorkDetails.stateProvinceCode = $event; });
    i0.ɵɵtemplate(5, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_7_ng_template_5_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r138 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r138.listStates)("ngModel", ctx_r138.beneficiaryWorkDetails.stateProvinceCode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelementStart(1, "label", 128);
    i0.ɵɵtext(2, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 120, 121);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_8_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r149); const ctx_r148 = i0.ɵɵnextContext(8); return ctx_r148.beneficiaryWorkDetails.stateProvinceName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r139 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r139.beneficiaryWorkDetails.stateProvinceName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r151 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 67);
    i0.ɵɵelementStart(2, "label", 122);
    i0.ɵɵtext(3, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 123, 110);
    i0.ɵɵlistener("onChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r151); const ctx_r150 = i0.ɵɵnextContext(7); return ctx_r150.handleCountryChange($event.value); })("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r151); const ctx_r152 = i0.ɵɵnextContext(7); return ctx_r152.beneficiaryWorkDetails.countryCode = $event; });
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_ng_template_6_Template, 2, 1, "ng-template", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_7_Template, 6, 2, "div", 44);
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_div_8_Template, 5, 1, "div", 44);
    i0.ɵɵelementStart(9, "div", 67);
    i0.ɵɵelementStart(10, "label", 124);
    i0.ɵɵtext(11, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 112, 113);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r151); const ctx_r153 = i0.ɵɵnextContext(7); return ctx_r153.beneficiaryWorkDetails.city = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r47.listCountry)("ngModel", ctx_r47.beneficiaryWorkDetails.countryCode);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r47.listStates.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r47.listStates.length);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r47.beneficiaryWorkDetails.city);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_34_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 133);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r155 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r155.getGlobalErrorMessages("ZIPCODE_ONLY"), " ");
} }
const _c2$1 = function (a0) { return { "im-input-error": a0 }; };
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r157 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 67);
    i0.ɵɵelementStart(2, "label", 129);
    i0.ɵɵtext(3, "Zip Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 130, 131);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_34_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r157); const ctx_r156 = i0.ɵɵnextContext(7); return ctx_r156.beneficiaryWorkDetails.zipCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_34_span_6_Template, 2, 1, "span", 132);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r154 = i0.ɵɵreference(5);
    i0.ɵɵnextContext();
    const _r27 = i0.ɵɵreference(2);
    const ctx_r48 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$1, _r154.touched || _r27.submitted))("ngModel", ctx_r48.beneficiaryWorkDetails.zipCode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (_r154.touched || _r27.submitted) && (_r154.errors == null ? null : _r154.errors.pattern));
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r160 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 67);
    i0.ɵɵelementStart(2, "label", 129);
    i0.ɵɵtext(3, "Zip Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 134, 131);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_35_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r160); const ctx_r159 = i0.ɵɵnextContext(7); return ctx_r159.beneficiaryWorkDetails.zipCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r49.beneficiaryWorkDetails.zipCode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r168 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "lib-custom-questionnaire", 138);
    i0.ɵɵlistener("refreshList", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_div_1_div_1_Template_lib_custom_questionnaire_refreshList_1_listener($event) { i0.ɵɵrestoreView(_r168); const ctx_r167 = i0.ɵɵnextContext(11); return ctx_r167.onRefreshPage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r166 = i0.ɵɵnextContext(11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", false)("loadedIn", "Work Experience Details")("beneficiaryId", ctx_r166.beneficiaryId)("isSection", true)("familyId", ctx_r166.familyId);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 137);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r165 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r165 == null ? null : item_r165.key) == "QTPROFILEBEN" && item_r165.selected == true);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_div_1_Template, 2, 1, "div", 136);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r162 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r162.stakeHoldersSelected);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r162 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r162.name == "Work Experience Details");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_div_1_Template, 2, 1, "div", 135);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r50.customQuestions == null ? null : ctx_r50.customQuestions.sectionList);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r177 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "lib-custom-questionnaire", 138);
    i0.ɵɵlistener("refreshList", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_div_1_div_1_Template_lib_custom_questionnaire_refreshList_1_listener($event) { i0.ɵɵrestoreView(_r177); const ctx_r176 = i0.ɵɵnextContext(11); return ctx_r176.onRefreshPage($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r175 = i0.ɵɵnextContext(11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isNewPortion", false)("viewQuestions", false)("loadedIn", "Work Experience Details")("beneficiaryId", ctx_r175.beneficiaryId)("isSection", true)("familyId", ctx_r175.familyId);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 137);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_div_1_div_1_Template, 2, 6, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r174 = ctx.$implicit;
    const ctx_r173 = i0.ɵɵnextContext(10);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r173.selectedUser == null ? null : ctx_r173.selectedUser.dependentType == null ? null : ctx_r173.selectedUser.dependentType.code) == item_r174.key && item_r174.selected == true);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_div_1_Template, 2, 1, "div", 136);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r171 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ques_r171.stakeHoldersSelected);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_div_1_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ques_r171 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ques_r171.name == "Work Experience Details");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_div_1_Template, 2, 1, "div", 135);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r51.customQuestions == null ? null : ctx_r51.customQuestions.sectionList);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r180 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵelementStart(1, "button", 139);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_42_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r180); i0.ɵɵnextContext(); const _r27 = i0.ɵɵreference(2); const ctx_r179 = i0.ɵɵnextContext(6); return ctx_r179.closeForm(_r27); });
    i0.ɵɵelementStart(2, "span", 140);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_button_44_Template(rf, ctx) { if (rf & 1) {
    const _r182 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 141);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_button_44_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r182); i0.ɵɵnextContext(); const _r27 = i0.ɵɵreference(2); const ctx_r181 = i0.ɵɵnextContext(6); return ctx_r181.saveEmployment(_r27, false, null); });
    i0.ɵɵelementStart(1, "span", 142);
    i0.ɵɵtext(2, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c3$1 = function (a0) { return { disabledView: a0 }; };
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelementStart(1, "form", 40, 41);
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_3_Template, 5, 1, "div", 42);
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵtemplate(5, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_5_Template, 5, 1, "div", 43);
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_6_Template, 5, 1, "div", 43);
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_7_Template, 6, 2, "div", 44);
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_8_Template, 6, 2, "div", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵtemplate(10, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_10_Template, 9, 4, "div", 44);
    i0.ɵɵtemplate(11, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_11_Template, 9, 4, "div", 44);
    i0.ɵɵtemplate(12, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_12_Template, 8, 5, "div", 44);
    i0.ɵɵtemplate(13, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_13_Template, 8, 5, "div", 44);
    i0.ɵɵtemplate(14, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_14_Template, 9, 3, "div", 44);
    i0.ɵɵelementStart(15, "div", 45);
    i0.ɵɵelementStart(16, "label", 46);
    i0.ɵɵtext(17, "Scheduled Weekly Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "input", 47, 48);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_Template_input_ngModelChange_18_listener($event) { i0.ɵɵrestoreView(_r184); const ctx_r183 = i0.ɵɵnextContext(6); return ctx_r183.beneficiaryWorkDetails.scheduledWeeklyHours = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 25);
    i0.ɵɵelementStart(21, "div", 49);
    i0.ɵɵelementStart(22, "div", 50);
    i0.ɵɵelement(23, "mat-divider");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_h5_24_Template, 2, 0, "h5", 51);
    i0.ɵɵelementStart(25, "div", 25);
    i0.ɵɵtemplate(26, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_26_Template, 5, 1, "div", 52);
    i0.ɵɵtemplate(27, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_27_Template, 5, 1, "div", 52);
    i0.ɵɵtemplate(28, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_28_Template, 8, 5, "div", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_29_Template, 6, 1, "div", 53);
    i0.ɵɵtemplate(30, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_30_Template, 6, 1, "div", 53);
    i0.ɵɵtemplate(31, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_31_Template, 5, 1, "div", 53);
    i0.ɵɵtemplate(32, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_32_Template, 14, 6, "div", 53);
    i0.ɵɵtemplate(33, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_33_Template, 14, 5, "div", 53);
    i0.ɵɵtemplate(34, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_34_Template, 7, 5, "div", 53);
    i0.ɵɵtemplate(35, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_35_Template, 6, 1, "div", 53);
    i0.ɵɵelementStart(36, "div", 25);
    i0.ɵɵtemplate(37, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_37_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(38, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_38_Template, 2, 1, "div", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 54);
    i0.ɵɵelement(40, "hr");
    i0.ɵɵelementStart(41, "div", 55);
    i0.ɵɵtemplate(42, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_div_42_Template, 4, 0, "div", 56);
    i0.ɵɵelementStart(43, "div", 57);
    i0.ɵɵtemplate(44, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_button_44_Template, 3, 0, "button", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c3$1, ctx_r15.isViewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPENDDT") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPDESGNTN") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPTYPE") ? true : false : false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPFROMDT") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest && !ctx_r15.beneficiaryWorkDetails.isCurrentRole);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPENDDT") ? true : false : false) && !ctx_r15.beneficiaryWorkDetails.isCurrentRole);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPSAL") ? true : false : true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r15.beneficiaryWorkDetails.scheduledWeeklyHours);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPADDR") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPNAME") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPCONTACTNO") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPADDR") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPADDR") ? true : false : true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPADDR") ? true : false : false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.iscaseRequest);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.iscaseRequest ? ctx_r15.currentItemDisplay.includes("EMPADDR") ? true : false : false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r15.beneficiaryType == "self");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.beneficiaryType !== "self");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r15.modeVal);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r15.viewMode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 143);
    i0.ɵɵtext(1, "Clients");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_label_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 165);
    i0.ɵɵtext(1, "End Date");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_label_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 166);
    i0.ɵɵtext(1, "End Date");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_button_31_Template(rf, ctx) { if (rf & 1) {
    const _r196 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 141);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_button_31_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r196); i0.ɵɵnextContext(); const _r185 = i0.ɵɵreference(1); const ctx_r195 = i0.ɵɵnextContext(6); return ctx_r195.addClientDetails(_r185); });
    i0.ɵɵelementStart(1, "span", 167);
    i0.ɵɵtext(2, "Add Client Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_mat_list_item_16_mat_icon_16_Template(rf, ctx) { if (rf & 1) {
    const _r206 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 180);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_mat_list_item_16_mat_icon_16_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r206); const item_r198 = i0.ɵɵnextContext().$implicit; const ctx_r204 = i0.ɵɵnextContext(8); return ctx_r204.removeClientItem(item_r198.id); });
    i0.ɵɵtext(1, " delete ");
    i0.ɵɵelementEnd();
} }
const _c4$1 = function (a0) { return { evenBg: a0 }; };
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_mat_list_item_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item", 11);
    i0.ɵɵelementStart(1, "div", 170);
    i0.ɵɵelementStart(2, "div", 176);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 177);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 170);
    i0.ɵɵelementStart(7, "div", 178);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 170);
    i0.ɵɵelementStart(11, "div", 178);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 170);
    i0.ɵɵelementStart(15, "div", 178);
    i0.ɵɵtemplate(16, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_mat_list_item_16_mat_icon_16_Template, 2, 0, "mat-icon", 179);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r198 = ctx.$implicit;
    const i_r199 = ctx.index;
    const even_r200 = ctx.even;
    const ctx_r197 = i0.ɵɵnextContext(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c4$1, even_r200));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i_r199 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "clientNameTxt", i_r199, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r198.clientName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 7, item_r198.startDate));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 9, item_r198.endDate));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r197.viewMode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list", 168);
    i0.ɵɵelementStart(1, "div", 169);
    i0.ɵɵtext(2, " Clients added ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-list-item");
    i0.ɵɵelementStart(4, "div", 170);
    i0.ɵɵelementStart(5, "div", 171);
    i0.ɵɵtext(6, "Client Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 170);
    i0.ɵɵelementStart(8, "div", 172);
    i0.ɵɵtext(9, "From");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 170);
    i0.ɵɵelementStart(11, "div", 173);
    i0.ɵɵtext(12, "To");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 170);
    i0.ɵɵelementStart(14, "div", 174);
    i0.ɵɵtext(15, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_mat_list_item_16_Template, 17, 13, "mat-list-item", 175);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r194 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("ngForOf", ctx_r194.beneficiaryWorkDetails.clients);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template(rf, ctx) { if (rf & 1) {
    const _r208 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 40, 144);
    i0.ɵɵelementStart(2, "div", 145);
    i0.ɵɵelementStart(3, "h5", 146);
    i0.ɵɵtext(4, "Clients worked with");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "div", 147);
    i0.ɵɵelementStart(7, "label", 148);
    i0.ɵɵtext(8, "Client Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 149, 150);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r208); const ctx_r207 = i0.ɵɵnextContext(6); return ctx_r207.client.clientName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 151);
    i0.ɵɵelementStart(12, "div", 67);
    i0.ɵɵelementStart(13, "label", 152);
    i0.ɵɵtext(14, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "mat-form-field", 153);
    i0.ɵɵelementStart(16, "input", 154, 155);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template_input_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r208); const ctx_r209 = i0.ɵɵnextContext(6); return ctx_r209.client.startDate = $event; })("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template_input_click_16_listener() { i0.ɵɵrestoreView(_r208); const _r188 = i0.ɵɵreference(20); return _r188.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "mat-datepicker-toggle", 78);
    i0.ɵɵelement(19, "mat-datepicker", 156, 157);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 67);
    i0.ɵɵtemplate(22, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_label_22_Template, 2, 0, "label", 158);
    i0.ɵɵtemplate(23, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_label_23_Template, 2, 0, "label", 159);
    i0.ɵɵelementStart(24, "mat-form-field", 153);
    i0.ɵɵelementStart(25, "input", 160, 161);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template_input_ngModelChange_25_listener($event) { i0.ɵɵrestoreView(_r208); const ctx_r211 = i0.ɵɵnextContext(6); return ctx_r211.client.endDate = $event; })("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template_input_click_25_listener() { i0.ɵɵrestoreView(_r208); const _r192 = i0.ɵɵreference(29); return _r192.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "mat-datepicker-toggle", 78);
    i0.ɵɵelement(28, "mat-datepicker", null, 162);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 67);
    i0.ɵɵtemplate(31, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_button_31_Template, 3, 0, "button", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 163);
    i0.ɵɵtemplate(33, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_mat_list_33_Template, 17, 1, "mat-list", 164);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r188 = i0.ɵɵreference(20);
    const _r192 = i0.ɵɵreference(29);
    const ctx_r17 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$1, ctx_r17.isViewMode));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngModel", ctx_r17.client.clientName);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r17.client.startDate)("min", ctx_r17.beneficiaryWorkDetails.startDate)("max", ctx_r17.beneficiaryWorkDetails.endDate)("matDatepicker", _r188);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r188);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("startAt", ctx_r17.beneficiaryWorkDetails.startDate);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r17.beneficiaryWorkDetails.isCurrentRole);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r17.beneficiaryWorkDetails.isCurrentRole);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r17.client.endDate)("matDatepicker", _r192)("min", ctx_r17.client.startDate)("max", ctx_r17.beneficiaryWorkDetails.endDate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r192);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r17.viewMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r17.beneficiaryWorkDetails.clients && ctx_r17.beneficiaryWorkDetails.clients.length > 0);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r214 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 181);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r214); const ctx_r213 = i0.ɵɵnextContext(6); return ctx_r213.closeForm(ctx_r213.clientForm); });
    i0.ɵɵelementStart(1, "span", 182);
    i0.ɵɵtext(2, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 183);
    i0.ɵɵtext(1, "List of Duties");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    const _r225 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 200);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_mat_icon_7_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r225); const i_r220 = i0.ɵɵnextContext().index; const ctx_r223 = i0.ɵɵnextContext(7); return ctx_r223.deleteSubDuties(i_r220); });
    i0.ɵɵtext(1, "delete_outline");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r227 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 197);
    i0.ɵɵelementStart(1, "mat-icon", 201);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_div_8_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r227); const ctx_r226 = i0.ɵɵnextContext(8); return ctx_r226.addSubDuties(); });
    i0.ɵɵtext(2, " add_circle_outline ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div", 194);
    i0.ɵɵelementStart(2, "div", 195);
    i0.ɵɵelementStart(3, "label", 34);
    i0.ɵɵtext(4, "Sub-Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 196);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_Template_input_ngModelChange_5_listener($event) { const subDuty_r219 = ctx.$implicit; return subDuty_r219.subDutyDescription = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 197);
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_mat_icon_7_Template, 2, 0, "mat-icon", 198);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_div_8_Template, 3, 0, "div", 199);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subDuty_r219 = ctx.$implicit;
    const i_r220 = ctx.index;
    const ctx_r217 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("name", i_r220);
    i0.ɵɵproperty("ngModel", subDuty_r219.subDutyDescription);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r217.duty.subDuties.length > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r217.duty.subDuties.length - 1 === i_r220);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 211);
    i0.ɵɵelementStart(1, "P", 212);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r238 = ctx.$implicit;
    const i_r231 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "subDutyText", i_r231, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", subItem_r238.subDutyDescription, " ");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_mat_icon_10_Template(rf, ctx) { if (rf & 1) {
    const _r241 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 213);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_mat_icon_10_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r241); const item_r230 = i0.ɵɵnextContext().$implicit; i0.ɵɵnextContext(2); const _r215 = i0.ɵɵreference(1); const ctx_r240 = i0.ɵɵnextContext(6); ctx_r240.resetJobDuties(_r215); ctx_r240.editDuty(item_r230); return ctx_r240.formCheck(ctx_r240.benExpForm["form"], ctx_r240.clientForm, _r215, ctx_r240.toolsAndTech); });
    i0.ɵɵtext(1, " edit ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_mat_icon_11_Template(rf, ctx) { if (rf & 1) {
    const _r245 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 180);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_mat_icon_11_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r245); const item_r230 = i0.ɵɵnextContext().$implicit; i0.ɵɵnextContext(2); const _r215 = i0.ɵɵreference(1); const ctx_r243 = i0.ɵɵnextContext(6); ctx_r243.removeJobDuty(item_r230.dutyId); return ctx_r243.resetJobDuties(_r215); });
    i0.ɵɵtext(1, " delete ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item", 208);
    i0.ɵɵelementStart(1, "div", 170);
    i0.ɵɵelementStart(2, "div", 176);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 177);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 170);
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_div_7_Template, 3, 2, "div", 209);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 170);
    i0.ɵɵelementStart(9, "div", 178);
    i0.ɵɵtemplate(10, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_mat_icon_10_Template, 2, 0, "mat-icon", 210);
    i0.ɵɵtemplate(11, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_mat_icon_11_Template, 2, 0, "mat-icon", 179);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r230 = ctx.$implicit;
    const i_r231 = ctx.index;
    const even_r232 = ctx.even;
    const ctx_r229 = i0.ɵɵnextContext(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c4$1, even_r232));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i_r231 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "dutyText", i_r231, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r230.duty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r230.subDuties);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r229.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r229.viewMode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list");
    i0.ɵɵelementStart(1, "div", 202);
    i0.ɵɵtext(2, " Added Duties ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-list-item", 203);
    i0.ɵɵelementStart(4, "div", 170);
    i0.ɵɵelementStart(5, "div", 204);
    i0.ɵɵtext(6, "Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 170);
    i0.ɵɵelementStart(8, "div", 205);
    i0.ɵɵtext(9, "Sub-Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 170);
    i0.ɵɵelementStart(11, "div", 206);
    i0.ɵɵtext(12, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_mat_list_item_13_Template, 12, 9, "mat-list-item", 207);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r218 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("ngForOf", ctx_r218.beneficiaryWorkDetails.jobDuties);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_Template(rf, ctx) { if (rf & 1) {
    const _r247 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 184, 185);
    i0.ɵɵlistener("ngSubmit", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r247); const _r215 = i0.ɵɵreference(1); return _r215.form.valid; });
    i0.ɵɵelementStart(2, "div", 145);
    i0.ɵɵelementStart(3, "div", 186);
    i0.ɵɵelementStart(4, "div", 187);
    i0.ɵɵelementStart(5, "label", 188);
    i0.ɵɵtext(6, "Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "input", 189, 190);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r247); const ctx_r248 = i0.ɵɵnextContext(6); return ctx_r248.duty.duty = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_div_9_Template, 9, 4, "div", 191);
    i0.ɵɵelementStart(10, "div", 25);
    i0.ɵɵelementStart(11, "div", 60);
    i0.ɵɵelementStart(12, "button", 192);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r247); const _r215 = i0.ɵɵreference(1); const ctx_r249 = i0.ɵɵnextContext(6); ctx_r249.addJobDuties(ctx_r249.duty); return ctx_r249.resetJobDuties(_r215); });
    i0.ɵɵelementStart(13, "span", 193);
    i0.ɵɵtext(14, "Add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 163);
    i0.ɵɵtemplate(16, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_mat_list_16_Template, 14, 1, "mat-list", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r215 = i0.ɵɵreference(1);
    const ctx_r20 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3$1, ctx_r20.isViewMode));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r20.duty.duty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r20.duty.subDuties);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", _r215.invalid);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r20.beneficiaryWorkDetails.jobDuties && ctx_r20.beneficiaryWorkDetails.jobDuties.length > 0);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_24_Template(rf, ctx) { if (rf & 1) {
    const _r251 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 214);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_24_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r251); const ctx_r250 = i0.ɵɵnextContext(6); return ctx_r250.closeForm(ctx_r250.dutiesForm); });
    i0.ɵɵelementStart(1, "span", 215);
    i0.ɵɵtext(2, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1, "Tools");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2, " & ");
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵtext(4, "Technologies");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_chip_6_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 231);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_chip_6_Template(rf, ctx) { if (rf & 1) {
    const _r261 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 228);
    i0.ɵɵlistener("removed", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_chip_6_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r261); const item_r257 = ctx.$implicit; const ctx_r260 = i0.ɵɵnextContext(7); return ctx_r260.removeToolsChip(item_r257); });
    i0.ɵɵelementStart(1, "span", 229);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_chip_6_mat_icon_3_Template, 2, 0, "mat-icon", 230);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r257 = ctx.$implicit;
    const i_r258 = ctx.index;
    const ctx_r254 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("selectable", ctx_r254.selectable)("removable", ctx_r254.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "skillNameId", i_r258, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", item_r257.skillName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r254.removable);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_mat_list_item_18_mat_icon_8_Template(rf, ctx) { if (rf & 1) {
    const _r271 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 180);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_mat_list_item_18_mat_icon_8_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r271); const item_r263 = i0.ɵɵnextContext().$implicit; const ctx_r269 = i0.ɵɵnextContext(8); return ctx_r269.removeToolsTechnology(item_r263.id); });
    i0.ɵɵtext(1, " delete ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_mat_list_item_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-item", 11);
    i0.ɵɵelementStart(1, "div", 170);
    i0.ɵɵelementStart(2, "div", 176);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 177);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 170);
    i0.ɵɵelementStart(7, "div", 178);
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_mat_list_item_18_mat_icon_8_Template, 2, 0, "mat-icon", 179);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r263 = ctx.$implicit;
    const i_r264 = ctx.index;
    const even_r265 = ctx.even;
    const ctx_r262 = i0.ɵɵnextContext(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4$1, even_r265));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i_r264 + 1, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "skillNameText+", i_r264, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r263.skillName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r262.viewMode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list");
    i0.ɵɵelementStart(1, "div", 232);
    i0.ɵɵelementStart(2, "span", 34);
    i0.ɵɵtext(3, "Added Tools");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " & ");
    i0.ɵɵelementStart(5, "span", 34);
    i0.ɵɵtext(6, "Technologies");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-list-item");
    i0.ɵɵelementStart(8, "div", 170);
    i0.ɵɵelementStart(9, "div", 233);
    i0.ɵɵelementStart(10, "span", 34);
    i0.ɵɵtext(11, "Tools");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, " & ");
    i0.ɵɵelementStart(13, "span", 34);
    i0.ɵɵtext(14, "Technologies");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 170);
    i0.ɵɵelementStart(16, "div", 234);
    i0.ɵɵtext(17, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_mat_list_item_18_Template, 9, 7, "mat-list-item", 175);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r256 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(18);
    i0.ɵɵproperty("ngForOf", ctx_r256.beneficiaryWorkDetails.tools);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_Template(rf, ctx) { if (rf & 1) {
    const _r273 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 216, 217);
    i0.ɵɵelementStart(2, "div", 145);
    i0.ɵɵelementStart(3, "mat-form-field", 218);
    i0.ɵɵelementStart(4, "mat-chip-list", 219, 220);
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_chip_6_Template, 4, 5, "mat-chip", 221);
    i0.ɵɵelementStart(7, "input", 222, 223);
    i0.ɵɵlistener("ngModelChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r273); const ctx_r272 = i0.ɵɵnextContext(6); return ctx_r272.toolsAndTechChip = $event; })("paste", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_Template_input_paste_7_listener($event) { i0.ɵɵrestoreView(_r273); const ctx_r274 = i0.ɵɵnextContext(6); return ctx_r274.pasteChips($event); })("matChipInputTokenEnd", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_Template_input_matChipInputTokenEnd_7_listener($event) { i0.ɵɵrestoreView(_r273); const ctx_r275 = i0.ɵɵnextContext(6); return ctx_r275.add($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-hint", 224);
    i0.ɵɵtext(10, "Please enter comma separated values");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 225);
    i0.ɵɵelementStart(12, "button", 226);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r273); const _r252 = i0.ɵɵreference(1); const ctx_r276 = i0.ɵɵnextContext(6); return ctx_r276.addToolsTechnologies(_r252); });
    i0.ɵɵelementStart(13, "span", 227);
    i0.ɵɵtext(14, "ADD");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 163);
    i0.ɵɵtemplate(16, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_mat_list_16_Template, 19, 1, "mat-list", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r253 = i0.ɵɵreference(5);
    const ctx_r23 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r23.listToolsTechnology);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matChipInputFor", _r253)("ngModel", ctx_r23.toolsAndTechChip)("matChipInputSeparatorKeyCodes", ctx_r23.separatorKeysCodes)("matChipInputAddOnBlur", ctx_r23.addOnBlur);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", ctx_r23.listToolsTechnology.length === 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r23.beneficiaryWorkDetails.tools && ctx_r23.beneficiaryWorkDetails.tools.length > 0);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_40_Template(rf, ctx) { if (rf & 1) {
    const _r278 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 181);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_40_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r278); const ctx_r277 = i0.ɵɵnextContext(6); return ctx_r277.closeForm(ctx_r277.toolsAndTech); });
    i0.ɵɵelementStart(1, "span", 235);
    i0.ɵɵtext(2, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 236);
    i0.ɵɵtext(1, "Upload Documents");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_div_43_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r282 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 181);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_div_43_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r282); i0.ɵɵnextContext(); const _r279 = i0.ɵɵreference(7); const ctx_r281 = i0.ɵɵnextContext(6); return ctx_r281.closeForm(_r279); });
    i0.ɵɵelementStart(1, "span", 241);
    i0.ɵɵtext(2, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_div_43_Template(rf, ctx) { if (rf & 1) {
    const _r284 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "p", 237);
    i0.ɵɵtext(3, " Select the related work experience documents and then click upload to save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵelementStart(5, "div", 49);
    i0.ɵɵelementStart(6, "form", 238, 239);
    i0.ɵɵelementStart(8, "file-upload-deafult-library", 240);
    i0.ɵɵlistener("fileUploadSuccess", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_div_43_Template_file_upload_deafult_library_fileUploadSuccess_8_listener() { i0.ɵɵrestoreView(_r284); const ctx_r283 = i0.ɵɵnextContext(6); return ctx_r283.fileUploadSuccess(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "hr");
    i0.ɵɵelementStart(10, "div", 25);
    i0.ɵɵelementStart(11, "div", 26);
    i0.ɵɵtemplate(12, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_div_43_button_12_Template, 3, 0, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3$1, ctx_r26.isViewMode));
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("isWizard", ctx_r26.isWizard)("primaryData", ctx_r26.primaryData)("configurations", ctx_r26.experienceFileUploadConfigurations);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r26.modeVal);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_Template(rf, ctx) { if (rf & 1) {
    const _r286 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-card", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "i", 19);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r286); const ctx_r285 = i0.ɵɵnextContext(5); return ctx_r285.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-tab-group", 20);
    i0.ɵɵlistener("selectedTabChange", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_Template_mat_tab_group_selectedTabChange_3_listener() { i0.ɵɵrestoreView(_r286); const ctx_r287 = i0.ɵɵnextContext(5); return ctx_r287.tabChange(); });
    i0.ɵɵelementStart(4, "mat-tab");
    i0.ɵɵtemplate(5, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_5_Template, 2, 0, "ng-template", 21);
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_6_Template, 45, 29, "ng-template", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-tab", 23);
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_8_Template, 2, 0, "ng-template", 21);
    i0.ɵɵtemplate(9, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_9_Template, 34, 19, "form", 24);
    i0.ɵɵelement(10, "hr");
    i0.ɵɵelementStart(11, "div", 25);
    i0.ɵɵelementStart(12, "div", 26);
    i0.ɵɵtemplate(13, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_13_Template, 3, 0, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "mat-tab", 23);
    i0.ɵɵtemplate(15, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_15_Template, 2, 0, "ng-template", 21);
    i0.ɵɵelementStart(16, "div", 28);
    i0.ɵɵelementStart(17, "div", 25);
    i0.ɵɵelementStart(18, "h5", 29);
    i0.ɵɵtext(19, "List of Duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_20_Template, 17, 7, "form", 30);
    i0.ɵɵelement(21, "hr");
    i0.ɵɵelementStart(22, "div", 25);
    i0.ɵɵelementStart(23, "div", 26);
    i0.ɵɵtemplate(24, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_24_Template, 3, 0, "button", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "mat-tab", 23);
    i0.ɵɵtemplate(26, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_26_Template, 5, 0, "ng-template", 21);
    i0.ɵɵelementStart(27, "div", 32);
    i0.ɵɵelementStart(28, "div", 25);
    i0.ɵɵelementStart(29, "h5", 33);
    i0.ɵɵelementStart(30, "span", 34);
    i0.ɵɵtext(31, "List of Tools");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(32, " & ");
    i0.ɵɵelementStart(33, "span", 34);
    i0.ɵɵtext(34, "Technologies");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 35);
    i0.ɵɵtemplate(36, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_form_36_Template, 17, 7, "form", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "hr");
    i0.ɵɵelementStart(38, "div", 25);
    i0.ɵɵelementStart(39, "div", 26);
    i0.ɵɵtemplate(40, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_button_40_Template, 3, 0, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "mat-tab", 23);
    i0.ɵɵtemplate(42, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_ng_template_42_Template, 2, 0, "ng-template", 21);
    i0.ɵɵtemplate(43, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_div_43_Template, 13, 7, "div", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", !ctx_r13.hasID);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.iscaseRequest ? ctx_r13.currentItemDisplay.includes("CLIENTWORK") ? true : false : true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r13.modeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !ctx_r13.hasID);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r13.iscaseRequest ? ctx_r13.currentItemDisplay.includes("LISTDUTIE") ? true : false : true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r13.modeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !ctx_r13.hasID);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$1, ctx_r13.isViewMode));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", ctx_r13.iscaseRequest ? ctx_r13.currentItemDisplay.includes("LISTTOOL") ? true : false : true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r13.modeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !ctx_r13.hasID);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.iscaseRequest ? ctx_r13.currentItemDisplay.includes("UPLOADDOC") ? true : false : true);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-accordion");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_mat_card_1_Template, 44, 14, "mat-card", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.showTabs);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtemplate(2, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_button_2_Template, 3, 0, "button", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_mat_accordion_3_Template, 2, 1, "mat-accordion", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$1, ctx_r2.isViewMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c3$1, ctx_r2.isViewMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.updateBenProfile && !ctx_r2.viewMode && ctx_r2.showEditButton && !ctx_r2.showTabs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showEditButton);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 244);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r292 = i0.ɵɵnextContext();
    const indx_r289 = ctx_r292.index;
    const column_r288 = ctx_r292.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "colHeaderLbl", indx_r289, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r288.header, " ");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r299 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 248);
    i0.ɵɵelementStart(1, "mat-icon", 249);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_span_1_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r299); const ctx_r298 = i0.ɵɵnextContext(5); return ctx_r298.tabChange(); });
    i0.ɵɵtext(2, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    const _r306 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 255);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_mat_icon_2_Template_mat_icon_click_0_listener($event) { i0.ɵɵrestoreView(_r306); const row_r293 = i0.ɵɵnextContext(4).$implicit; const ctx_r304 = i0.ɵɵnextContext(4); $event.stopPropagation(); ctx_r304.handleEdit(row_r293); ctx_r304.handleShowTabs(); return ctx_r304.formCheck(ctx_r304.benExpForm["form"], ctx_r304.clientForm, ctx_r304.dutiesForm, ctx_r304.toolsAndTech); });
    i0.ɵɵtext(1, " edit ");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r309 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 256);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_mat_icon_3_Template_mat_icon_click_0_listener($event) { i0.ɵɵrestoreView(_r309); const row_r293 = i0.ɵɵnextContext(4).$implicit; const ctx_r307 = i0.ɵɵnextContext(4); ctx_r307.handleDeleteExperience(row_r293); return $event.stopPropagation(); });
    i0.ɵɵtext(1, "delete_forever");
    i0.ɵɵelementEnd();
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 251);
    i0.ɵɵelementStart(1, "span", 252);
    i0.ɵɵtemplate(2, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_mat_icon_2_Template, 2, 0, "mat-icon", 253);
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_mat_icon_3_Template, 2, 0, "mat-icon", 254);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r301 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r301.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r301.viewMode);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_span_1_Template, 4, 2, "span", 250);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r288 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r288.columnType == "icon");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_ng_container_1_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r296 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r296.isExternalEmployeeId);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 229);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r312 = i0.ɵɵnextContext();
    const i_r294 = ctx_r312.renderIndex;
    const row_r293 = ctx_r312.$implicit;
    const ctx_r311 = i0.ɵɵnextContext();
    const indx_r289 = ctx_r311.index;
    const column_r288 = ctx_r311.$implicit;
    i0.ɵɵpropertyInterpolate2("id", "colTextLbl_", indx_r289, "__", i_r294, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r293[column_r288.columnDef], " ");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 245);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_span_1_Template, 3, 0, "span", 246);
    i0.ɵɵtemplate(2, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_div_2_Template, 2, 1, "div", 0);
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_span_3_Template, 2, 3, "span", 247);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r288 = i0.ɵɵnextContext().$implicit;
    const ctx_r291 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r288.columnDef == "toggle");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r291.updateBenProfile && ctx_r291.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r288.columnType == "text");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 242);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_th_1_Template, 2, 2, "th", 243);
    i0.ɵɵtemplate(2, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_td_2_Template, 4, 3, "td", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r288 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r288.columnDef);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_1_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 267);
    i0.ɵɵelementStart(1, "td", 262);
    i0.ɵɵelementStart(2, "div", 268);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 229);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r322 = ctx.$implicit;
    const i_r323 = ctx.index;
    const indx_r315 = i0.ɵɵnextContext(3).renderIndex;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r323 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "skillNameColText_", indx_r315, "_", i_r323, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r322.skillName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 260);
    i0.ɵɵelementStart(1, "h6", 229);
    i0.ɵɵtext(2, "List of Tools");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 264);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 262);
    i0.ɵɵelementStart(8, "th", 265);
    i0.ɵɵtext(9, "Tools&Technologies");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "tbody");
    i0.ɵɵtemplate(11, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_1_tr_11_Template, 6, 4, "tr", 266);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r325 = i0.ɵɵnextContext(2);
    const indx_r315 = ctx_r325.renderIndex;
    const element_r314 = ctx_r325.$implicit;
    const ctx_r317 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "__listOfTools_", indx_r315, "_", ctx_r317.i, "");
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngForOf", element_r314.tools);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_2_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 267);
    i0.ɵɵelementStart(1, "td", 262);
    i0.ɵɵelementStart(2, "div", 268);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 270);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 271);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 271);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "ImgDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r327 = ctx.$implicit;
    const ind2_r328 = ctx.index;
    const ctx_r326 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ind2_r328 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "clientNameColText_", ctx_r326.indx2, "", ind2_r328, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r327.clientName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 6, item_r327.startDate));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 8, item_r327.endDate));
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 260);
    i0.ɵɵelementStart(1, "h6", 269);
    i0.ɵɵtext(2, "List of Clients");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 264);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 262);
    i0.ɵɵelementStart(8, "th", 229);
    i0.ɵɵtext(9, "Client");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 229);
    i0.ɵɵtext(11, "From Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 229);
    i0.ɵɵtext(13, "To Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_2_tr_15_Template, 12, 10, "tr", 266);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r329 = i0.ɵɵnextContext(2);
    const indx_r315 = ctx_r329.renderIndex;
    const element_r314 = ctx_r329.$implicit;
    i0.ɵɵadvance(8);
    i0.ɵɵpropertyInterpolate1("id", "expClientCol_", indx_r315, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "expFromDateCol_", indx_r315, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "expToDateCol_", indx_r315, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", element_r314.clients);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_3_tr_13_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "P", 275);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r334 = ctx.$implicit;
    const inx_r332 = i0.ɵɵnextContext().index;
    const indx_r315 = i0.ɵɵnextContext(3).renderIndex;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "subDutyColText_", inx_r332, "", indx_r315, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(subItem_r334.subDutyDescription);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_3_tr_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 267);
    i0.ɵɵelementStart(1, "td", 262);
    i0.ɵɵelementStart(2, "div", 268);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 273);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 274);
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_3_tr_13_div_7_Template, 3, 3, "div", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r331 = ctx.$implicit;
    const inx_r332 = ctx.index;
    const indx_r315 = i0.ɵɵnextContext(3).renderIndex;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(inx_r332 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "dutyColText_", inx_r332, "_", indx_r315, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r331.duty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r331.subDuties);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 260);
    i0.ɵɵelementStart(1, "h6", 229);
    i0.ɵɵtext(2, "List of Duties");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 272);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 262);
    i0.ɵɵelementStart(8, "th", 229);
    i0.ɵɵtext(9, "Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 229);
    i0.ɵɵtext(11, "Sub Duty");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "tbody");
    i0.ɵɵtemplate(13, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_3_tr_13_Template, 8, 5, "tr", 266);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r338 = i0.ɵɵnextContext(2);
    const indx_r315 = ctx_r338.renderIndex;
    const element_r314 = ctx_r338.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "listOfDutiesLbl_", indx_r315, "");
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate1("id", "expDutyLbl_", indx_r315, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "expSubDutyLbl_", indx_r315, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", element_r314.jobDuties);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 262);
    i0.ɵɵelementStart(1, "div", 268);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ixx_r340 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ixx_r340 + 1, " ");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "strong", 229);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r346 = i0.ɵɵnextContext();
    const ixx_r340 = ctx_r346.index;
    const item_r339 = ctx_r346.$implicit;
    const ctx_r342 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "fileNameText_", ixx_r340, "_", ctx_r342.i, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r339.fileName);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 270);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r347 = i0.ɵɵnextContext();
    const ixx_r340 = ctx_r347.index;
    const item_r339 = ctx_r347.$implicit;
    const ctx_r343 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate2("id", "fileCategoryText_", ixx_r340, "_", ctx_r343.i, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (item_r339 == null ? null : item_r339.fileCategory == null ? null : item_r339.fileCategory.code) === "OTHER" ? item_r339 == null ? null : item_r339.fileCategoryOtherName : item_r339 == null ? null : item_r339.fileCategory == null ? null : item_r339.fileCategory.name, " ");
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-file-download", 279);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r339 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r348 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", item_r339.fileLocationName)("Path", ctx_r348.envPath + item_r339.fileLocation.substring(23));
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 271);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_4_ng_container_1_Template, 2, 2, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r339 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r339.fileLocation);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_1_Template, 3, 1, "td", 276);
    i0.ɵɵtemplate(2, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_2_Template, 3, 3, "td", 0);
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_3_Template, 2, 3, "td", 277);
    i0.ɵɵtemplate(4, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_td_4_Template, 2, 1, "td", 278);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r339 = ctx.$implicit;
    const ctx_r320 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r320.isI140 && item_r339.isPresent === true || !ctx_r320.isI140 && item_r339.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r320.isI140 && item_r339.isPresent === true || !ctx_r320.isI140 && item_r339.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r320.isI140 && item_r339.isPresent === true || !ctx_r320.isI140 && item_r339.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r320.isI140 && item_r339.isPresent === true || !ctx_r320.isI140);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 258);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_1_Template, 12, 3, "div", 259);
    i0.ɵɵtemplate(2, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_2_Template, 16, 4, "div", 259);
    i0.ɵɵtemplate(3, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_div_3_Template, 14, 4, "div", 259);
    i0.ɵɵelementStart(4, "div", 260);
    i0.ɵɵelementStart(5, "h6", 229);
    i0.ɵɵtext(6, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(7);
    i0.ɵɵelementStart(8, "table", 261);
    i0.ɵɵelementStart(9, "thead");
    i0.ɵɵelementStart(10, "tr");
    i0.ɵɵelement(11, "th", 262);
    i0.ɵɵelementStart(12, "th", 229);
    i0.ɵɵtext(13, "Document");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 229);
    i0.ɵɵtext(15, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵelement(17, "i", 263);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "tbody");
    i0.ɵɵtemplate(19, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_tr_19_Template, 5, 4, "tr", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r351 = i0.ɵɵnextContext();
    const element_r314 = ctx_r351.$implicit;
    const indx_r315 = ctx_r351.renderIndex;
    const ctx_r316 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("@detailExpand", element_r314 == ctx_r316.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r314.tools && element_r314.tools.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r314.clients && element_r314.clients.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r314.jobDuties && element_r314.jobDuties.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "listOfDocsLbl_", indx_r315, "");
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate1("id", "docLbl_", indx_r315, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "docTypeLbl_", indx_r315, "");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r314.documents);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 245);
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_div_1_Template, 20, 8, "div", 257);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r314 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("colspan", ctx_r4.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r314 && ctx_r4.expandedElement);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 280);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_8_Template(rf, ctx) { if (rf & 1) {
    const _r354 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 281);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_8_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r354); const row_r352 = ctx.$implicit; const ctx_r353 = i0.ɵɵnextContext(3); return ctx_r353.expandedElement = ctx_r353.expandedElement === row_r352 ? null : row_r352; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r352 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("example-expanded-row", ctx_r6.expandedElement === row_r352);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 282);
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_10_Template(rf, ctx) { if (rf & 1) {
    const _r357 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 283);
    i0.ɵɵelementStart(1, "td", 284);
    i0.ɵɵelementStart(2, "div", 285);
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵtext(4, "No Work Experience Added Yet. Click");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 286);
    i0.ɵɵlistener("click", function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_10_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r357); const ctx_r356 = i0.ɵɵnextContext(3); return ctx_r356.handleShowTabs(); });
    i0.ɵɵelementStart(6, "span", 287);
    i0.ɵɵtext(7, "Add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 34);
    i0.ɵɵtext(9, "to enter the details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c5 = function () { return ["expandedDetail"]; };
function GenericBeneficiaryWorkExperienceComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_1_Template, 4, 8, "ng-container", 1);
    i0.ɵɵelementStart(2, "mat-card", 2);
    i0.ɵɵelementStart(3, "table", 3);
    i0.ɵɵtemplate(4, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_ng_container_4_Template, 3, 1, "ng-container", 4);
    i0.ɵɵelementContainerStart(5, 5);
    i0.ɵɵtemplate(6, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_td_6_Template, 2, 2, "td", 6);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(7, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_7_Template, 1, 0, "tr", 7);
    i0.ɵɵtemplate(8, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_8_Template, 1, 2, "tr", 8);
    i0.ɵɵtemplate(9, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_9_Template, 1, 0, "tr", 9);
    i0.ɵɵtemplate(10, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_tr_10_Template, 10, 0, "tr", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isExternalEmployeeId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hidden", ctx_r1.showTabs);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r1.dataSource);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.columns);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r1.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r1.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(7, _c5));
} }
function GenericBeneficiaryWorkExperienceComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GenericBeneficiaryWorkExperienceComponent_div_0_div_1_Template, 11, 8, "div", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.visibleSubSection === "WORKEXP");
} }
class GenericBeneficiaryWorkExperienceComponent {
    constructor(refLibService, referenceLibraryService, toastr, changeDetector, route, dialog, cacheCountryService, store, dependentProfileDataService, appServicesLibraryService, genericBeneficiaryWorkExperienceService, dirtyFormGuard) {
        var _a, _b, _c, _d, _f;
        this.refLibService = refLibService;
        this.referenceLibraryService = referenceLibraryService;
        this.toastr = toastr;
        this.changeDetector = changeDetector;
        this.route = route;
        this.dialog = dialog;
        this.cacheCountryService = cacheCountryService;
        this.store = store;
        this.dependentProfileDataService = dependentProfileDataService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.genericBeneficiaryWorkExperienceService = genericBeneficiaryWorkExperienceService;
        this.dirtyFormGuard = dirtyFormGuard;
        this.iscaseRequest = false;
        this.currentItemDisplay = [];
        this.modeVal = false;
        this.beneficiaryWorkDetails = new WorkDetailsLib({});
        this.client = {
            clientName: '',
            id: null,
            startDate: null,
            endDate: null
        };
        // subscriptions: Subscription;
        this.duty = {
            duty: '',
            dutyId: null,
            sequenceNo: null,
            subDuties: [
                {
                    subDutyDescription: '',
                    subDutyId: null,
                    sequenceNo: null
                }
            ]
        };
        this.tool = {
            id: null,
            skillName: ''
        };
        this.listToolsTechnology = [];
        this.jobEditable = false;
        this.hasUnsavedData = false;
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.hasID = false;
        this.isLinear = true;
        this.isSaveCallFromDel = false;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.checked = false;
        this.displayedColumns = [];
        this.viewMode = false;
        this.isBenQuestShowDivs = false;
        this.destroy$ = new Subject();
        this.showEditButton = true;
        this.showTabs = false;
        this.updateBenProfile = true;
        this.expandPanel = false;
        this.isListView = false;
        this.isTimeLineView = true;
        this.visibleSubSection = "WORKEXP";
        this.payload = null;
        this.columns = [
            { columnDef: 'toggle', header: 'toggle', columnType: 'toggleicon', customClass: '' },
            { columnDef: 'designation', header: 'Title', columnType: 'text', customClass: '' },
            { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
            { columnDef: 'employmentTypeValue', header: 'Employment Type', columnType: 'text', customClass: '' },
            { columnDef: 'startDate', header: 'From ', columnType: 'text', customClass: '' },
            { columnDef: 'endDate', header: 'To', columnType: 'text', customClass: '' },
            { columnDef: 'salary', header: 'Salary', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.experienceFileUploadConfigurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENWEDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENWEDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            isDeleteEnabled: this.viewMode ? false : true,
            isUploadEnabled: this.viewMode ? false : true,
            familyId: null
        };
        this.dirtyFormList = {
            form1Dirty: false,
            form2Dirty: false,
            form3Dirty: false,
            form4Dirty: false
        };
        this.dirtyFormName = {
            form1Name: '',
            form2Name: '',
            form3Name: '',
            form4Name: '',
        };
        this.observableSubscription$ = new Subject();
        this.observableSubscriptionTranslet$ = new Subject();
        this.subscriptions = [];
        this.isSaveAsDraftDisabled = true;
        this.isLocked = false;
        this.listCountryOfficePhone = [];
        this.beneData = null;
        this.wizardData = {};
        // this.beneficiaryId = this.isWizard
        // ? this.primaryData.beneficiaryId
        // : sessionStorage.getItem('listBeneficiaryId')
        //   ? parseInt(sessionStorage.getItem('listBeneficiaryId'))
        //   : this.genericBeneficiaryWorkExperienceService.currentUserValue['beneficiaryId'];
        this.beneficiaryId = this.isWizard
            ? this.primaryData.beneficiaryId
            : sessionStorage.getItem('listBeneficiaryId')
                ? parseInt(sessionStorage.getItem('listBeneficiaryId'))
                : sessionStorage.getItem('beneficiaryId')
                    ? parseInt(sessionStorage.getItem('beneficiaryId'))
                    : this.genericBeneficiaryWorkExperienceService.currentUserValue['beneficiaryId'];
        //this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.genericBeneficiaryWorkExperienceService.currentUserValue['beneficiaryId'];
        this.listCountry = [];
        this.listStates = [];
        this.phoneTypeList = [];
        this.maxDate = new Date();
        this.isExternalEmployeeId = sessionStorage.getItem('_isExternalEmployeeId');
        if (this.isExternalEmployeeId) {
            this.isLocked = true;
        }
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
        //check for Wizard flag
        this.beneData = !!(localStorage.getItem('BeneData')) ? JSON.parse(localStorage.getItem('BeneData')) : null;
        //  this.isWizard = this.beneData?.version === 'WWF';
        if (this.isWizard) {
            this.wizardData = {
                visaType: (_a = this.beneData) === null || _a === void 0 ? void 0 : _a.visaType,
                caseType: (_b = this.beneData) === null || _b === void 0 ? void 0 : _b.taskTypeRef,
                caseId: (_c = this.beneData) === null || _c === void 0 ? void 0 : _c.petitionId,
                superTaskId: this.beneData.superTaskId,
                subTaskId: (_d = this.beneData) === null || _d === void 0 ? void 0 : _d.taskId,
                taskId: (_f = this.beneData) === null || _f === void 0 ? void 0 : _f.taskId,
            };
        }
    }
    ngOnInit() {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
        this.genericBeneficiaryWorkExperienceService.currentUser.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            if (sessionStorage.getItem('userTypeRole') === Roles.ATTORNEY || sessionStorage.getItem('userTypeRole') === Roles.PETITIONER) {
                this.updateBenProfile = this.genericBeneficiaryWorkExperienceService.checkBeneEditPermission();
                this.viewMode = !this.updateBenProfile;
            }
        });
        if (this.route.snapshot.paramMap.get('listview')) {
            this.toggleListView(true);
        }
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        if (this.onlyFormBuilder === 'FB') {
            this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
        }
        else {
            this.beneficiaryId = this.isWizard
                ? this.primaryData.beneficiaryId
                : sessionStorage.getItem('listBeneficiaryId')
                    ? parseInt(sessionStorage.getItem('listBeneficiaryId'))
                    : sessionStorage.getItem('beneficiaryId')
                        ? parseInt(sessionStorage.getItem('beneficiaryId'))
                        : this.genericBeneficiaryWorkExperienceService.currentUserValue['beneficiaryId'];
            //this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.genericBeneficiaryWorkExperienceService.currentUserValue['beneficiaryId'];
        }
        this.referenceLibraryService.getReferenceDataWithoutAuthentication('PHON').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.phoneTypeList = response;
        });
        this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.listCountry = data.listCountries.map((c) => {
                    c['labelWithCode'] = `${c.countryName} - ${c.phoneCode}`;
                    return c;
                });
                const defaultOption = { countryCode: null, countryName: 'Select', labelWithCode: 'Select', phoneCode: '' };
                this.referenceLibraryService.translateArray([defaultOption, ...this.listCountry], 'countryName')
                    .then(translated => {
                    this.listCountry = translated;
                })
                    .catch(error => console.error("Translation error:", error));
                this.referenceLibraryService.translateArray([...this.listCountry], 'labelWithCode')
                    .then(translated => {
                    this.listCountryOfficePhone = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
        });
        this.referenceLibraryService.getReferenceDataWithoutAuthentication('CURR').pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.referenceLibraryService.translateArray([{ code: "", name: "Select", id: 0, desc: '', group: '' }, ...data], 'name')
                .then(translated => {
                this.currencyTypeList = translated;
            })
                .catch(error => console.error("Translation error:", error));
        });
        this.referenceLibraryService.getReferenceDataWithoutAuthentication('EMPTYP').pipe(takeUntil(this.observableSubscription$)).subscribe((empTypeResponse) => {
            this.referenceLibraryService.translateArray(empTypeResponse, 'name')
                .then(translated => {
                this.listEmploymentType = translated;
            })
                .catch(error => console.error("Translation error:", error));
        });
        this.dependentIdSubscription = this.dependentProfileDataService.dependentProfileSubject.pipe(takeUntil(this.observableSubscription$)).subscribe((selectedBeneObj) => {
            var _a;
            // this.familyId = parseInt(sessionStorage.getItem('beneficiaryIdExp'));
            this.beneficiaryType = sessionStorage.getItem('beneficiaryTypeExp');
            this.familyId = this.primaryData ? (_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.familyId : selectedBeneObj.dependentId;
            //this.beneficiaryType = selectedBeneObj.beneficiaryType;
            this.showLifeStoryTimeLineSection = this.primaryData ? true : this.showLifeStoryTimeLineSection;
            //this.showLifeStoryTimeLineSection = (this.beneficiaryType === 'family' && this.familyId) ? true : (this.beneficiaryType === 'self') ? true : false;
            if (this.isBenQuestShowDivs && sessionStorage.getItem('isCaseRequest')) {
                if (this.beneficiaryType === 'self') {
                    this.iscaseRequest = true;
                }
                else {
                    this.iscaseRequest = false;
                }
                this.translet();
            }
            this.getBeneficiaryWorkDetails();
        });
        //  this.getBeneficiaryWorkDetails();
        this.genericBeneficiaryWorkExperienceService.onLifeStorySubTabs.next();
        this.envPath = environment.docs;
        //IM-3066 - remove deleted file.
        this.genericBeneficiaryWorkExperienceService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            if (status === true) {
                this.getBeneficiaryWorkDetails();
            }
        });
        this.genericBeneficiaryWorkExperienceService.uploaded$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            if (status === true) {
                this.getBeneficiaryWorkDetails();
            }
        });
        // console.log(this.clientForm_,"nnnn")
        this.initializeFormMonitoring();
        this.showEditButton = !this.genericBeneficiaryWorkExperienceService.checkValidity();
        if (localStorage.getItem('currentUserSelection')) {
            this.selectedUser = JSON.parse(localStorage.getItem('currentUserSelection'));
        }
        if (localStorage.getItem('customQuestions')) {
            this.customQuestions = JSON.parse(localStorage.getItem('customQuestions'));
        }
    }
    translet() {
        setTimeout(() => {
            this.referenceLibraryService.transletConversion();
            // this.referenceLibraryService.transletConversion().pipe(takeUntil(this.observableSubscription$)).subscribe((response:any) => {
            //   console.log(response);
            // });
        }, 600);
    }
    ngAfterViewInit() {
        this.changeDetector.detectChanges();
        if (this.modeVal) {
            this.showLifeStoryTimeLineSection = true;
            this.toggleListView(true);
            this.toggleExpansion();
        }
        this.cacheCountryService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.listCountries) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.listCountry = data.listCountries.map((c) => {
                    c['labelWithCode'] = `${c.countryName} - ${c.phoneCode}`;
                    return c;
                });
                // Add "Select" only once and translate it
                const defaultOption = { countryCode: null, countryName: 'Select', labelWithCode: 'Select', phoneCode: '' };
                this.referenceLibraryService.translateArray([defaultOption, ...this.listCountry], 'countryName')
                    .then(translated => {
                    this.listCountry = translated;
                })
                    .catch(error => console.error("Translation error:", error));
                this.referenceLibraryService.translateArray([...this.listCountry], 'labelWithCode')
                    .then(translated => {
                    this.listCountryOfficePhone = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
        });
        // console.log(this.clientForm_,"fffff")
        this.translet();
    }
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
    }
    initializeFormMonitoring() {
        let message;
        let formList;
        this.genericBeneficiaryWorkExperienceService.statusChangeSubScriptionSubjectStep.next(1);
        this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.subscribe(response => {
            switch (response.formNumber) {
                case 1:
                    this.dirtyFormList.form1Dirty = response.dirty;
                    this.dirtyFormName.form1Name = response.formName;
                    break;
                case 2:
                    this.dirtyFormList.form2Dirty = response.dirty;
                    this.dirtyFormName.form2Name = response.formName;
                    break;
                case 3:
                    this.dirtyFormList.form3Dirty = response.dirty;
                    this.dirtyFormName.form3Name = response.formName;
                    break;
                case 4:
                    this.dirtyFormList.form4Dirty = response.dirty;
                    this.dirtyFormName.form4Name = response.formName;
            }
            formList = this.dirtyFormName.form1Name ? this.dirtyFormName.form1Name + ',' : '' +
                this.dirtyFormName.form2Name ? this.dirtyFormName.form2Name + ',' : '' +
                this.dirtyFormName.form3Name ? this.dirtyFormName.form3Name + ',' : '' +
                this.dirtyFormName.form4Name ? this.dirtyFormName.form4Name + ',' : '';
            formList = formList.slice(0, -1);
            message = `If you leave before saving, all changes made on the ${formList} form will be lost. Do you wish to continue?`;
            if (!this.dirtyFormList.form1Dirty &&
                !this.dirtyFormList.form2Dirty &&
                !this.dirtyFormList.form3Dirty &&
                !this.dirtyFormList.form4Dirty) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
            }
            else {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: message
                }));
            }
        });
    }
    formCheck(benExpForm, clientForm, dutiesForm, toolsAndTech) {
        if (this.genericBeneficiaryWorkExperienceService.formChangesSubscription) {
            this.genericBeneficiaryWorkExperienceService.formChangesSubscription.unsubscribe();
        }
        this.benExpForm = benExpForm;
        benExpForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            this.genericBeneficiaryWorkExperienceService.statusChangeSubScriptionSubjectStep.next(1);
            if (benExpForm.dirty) {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: true, formName: 'Employment', formNumber: 1 });
            }
            else {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: false, formName: '', formNumber: 1 });
            }
        });
        this.subscriptions[0] = this.benExpForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((formValues) => {
            this.isSaveAsDraftDisabled = !Object.values(formValues).some((val) => !!val || val === 0);
        });
        clientForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            this.genericBeneficiaryWorkExperienceService.statusChangeSubScriptionSubjectStep.next(2);
            if (clientForm.dirty) {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: true, formName: 'Client', formNumber: 2 });
            }
            else {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: false, formName: '', formNumber: 2 });
            }
        });
        dutiesForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            this.genericBeneficiaryWorkExperienceService.statusChangeSubScriptionSubjectStep.next(3);
            if (dutiesForm.dirty) {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: true, formName: 'Duties', formNumber: 3 });
            }
            else {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: false, formName: '', formNumber: 3 });
            }
        });
        toolsAndTech.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            this.genericBeneficiaryWorkExperienceService.statusChangeSubScriptionSubjectStep.next(4);
            if (toolsAndTech.dirty) {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: true, formName: 'Tools and Technology', formNumber: 4 });
            }
            else {
                this.genericBeneficiaryWorkExperienceService.formIsDirtySubject.next({ dirty: false, formName: '', formNumber: 4 });
            }
        });
    }
    // IM-4368
    // getBeneficiaryDetails() {
    //     this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'experience', this.familyId).pipe(takeUntil(this.observableSubscription$),
    //       map((beneficiary: any[]) => {
    //         beneficiary = beneficiary.map((experience) => {
    //           const clients = [];
    //           if (experience.clients && experience.clients.length > 0) {
    //             experience.clients.forEach(val => {
    //               clients.push(val.clientName);
    //             });
    //           }
    //           return {
    //             ...experience,
    //             employmentTypeValue: experience.employmentType ? experience.employmentType['name'] : '',
    //             'clientsList': clients.join(','),
    //             'startDate': experience['startDate'] ? moment(experience['startDate']).format('DD-MMM-YYYY') : '',
    //             'endDate': experience['endDate'] ? moment(experience['endDate']).format('DD-MMM-YYYY') : 'Present'
    //           };
    //         });
    //         return beneficiary;
    //       }), shareReplay()
    //     );
    // }
    // GET api call & Main Table
    getBeneficiaryWorkDetails() {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m;
        this.dataSource = null;
        this.experienceData = [];
        if (sessionStorage.getItem('newFamilyId')) {
            this.familyId = sessionStorage.getItem('newFamilyId');
        }
        //Check if wizard then get petition level data
        //let getExpApi = this.isWizard ? this.genericBeneficiaryWorkExperienceService.getBeneExperienceInformation(this.primaryData?.visatype,this.primaryData?.caseType,this.primaryData?.caseId,'EXPERIENCE',this.primaryData?.superTaskId,this.primaryData?.subTaskId, true) :this.genericBeneficiaryWorkExperienceService.getBeneficiaryDetails(this.beneficiaryId, 'experience', this.familyId);
        let getExpApi = (this.isWizard && !this.isI140)
            ? this.genericBeneficiaryWorkExperienceService.getBeneExperienceInformation((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.visatype, (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.caseType, (_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.caseId, this.primaryData.caseType == 'I130' ? 'FEXPERIENCE' : 'EXPERIENCE', (_d = this.primaryData) === null || _d === void 0 ? void 0 : _d.superTaskId, (_f = this.primaryData) === null || _f === void 0 ? void 0 : _f.subTaskId, this.isTimeLine ? false : true, (_g = this.primaryData) === null || _g === void 0 ? void 0 : _g.familyId)
            : (this.isI140 && this.isWizard)
                ? (this.primaryData.caseType.toLowerCase() === 'perm'
                    ? this.genericBeneficiaryWorkExperienceService.onGetWorkExperienceDetailsPerm(this.primaryData.caseId, this.isTimeLine ? false : true)
                    : this.genericBeneficiaryWorkExperienceService.getBeneGCExperienceInformation((_h = this.primaryData) === null || _h === void 0 ? void 0 : _h.visatype, (_j = this.primaryData) === null || _j === void 0 ? void 0 : _j.caseType, (_k = this.primaryData) === null || _k === void 0 ? void 0 : _k.caseId, 'experience', (_l = this.primaryData) === null || _l === void 0 ? void 0 : _l.superTaskId, (_m = this.primaryData) === null || _m === void 0 ? void 0 : _m.subTaskId, this.isTimeLine ? false : true))
                : this.genericBeneficiaryWorkExperienceService.getBeneficiaryDetails(this.beneficiaryId, 'experience', this.familyId);
        // IM-4368
        getExpApi.pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
            beneficiary = Array.isArray(beneficiary) ? beneficiary : [];
            beneficiary = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.map((experience) => {
                var _a;
                const clients = [];
                if (experience.clients && experience.clients.length > 0) {
                    experience.clients.forEach(val => {
                        clients.push(val.clientName);
                    });
                }
                experience['documents'] = (_a = experience === null || experience === void 0 ? void 0 : experience.documents) === null || _a === void 0 ? void 0 : _a.map(e => {
                    let _e = Object.assign({}, e);
                    _e.fileLocationName = this.isFBUser ? (_e.fileLocation ? _e.fileLocation.split('/').slice(-1)[0] : null) : (_e.fileLocation ? _e.fileLocation.substring(23) : null);
                    return _e;
                });
                return Object.assign(Object.assign({}, experience), { employmentTypeValue: (experience === null || experience === void 0 ? void 0 : experience.employmentType) ? experience.employmentType['name'] : '', 'clientsList': clients.join(','), 'startDate': experience['startDate'] ? moment__default(experience['startDate']).format('DD-MMM-YYYY') : '', 'endDate': experience['endDate'] ? moment__default(experience['endDate']).format('DD-MMM-YYYY') : 'Present' });
            });
            this.hasUnsavedData = false;
            this.dataSource = new MatTableDataSource(beneficiary);
            this.experienceData = beneficiary || [];
            this.genericBeneficiaryWorkExperienceService.experienceChanged(this.experienceData);
            this.translet();
            // this.experienceData.forEach(item => {
            //   const clients = [];
            //   if (item.clients && item.clients.length > 0) {
            //     item.clients.forEach(val => {
            //       clients.push(val.clientName);
            //     });
            //   }
            //   item['clientsList'] = clients.join(',');
            //   item['startDate'] = (item['startDate']) ? moment(item['startDate']).format('DD-MMM-YYYY') : '';
            //   item['endDate'] = (item['endDate']) ? moment(item['endDate']).format('DD-MMM-YYYY') : 'Present';
            // });
        });
    }
    // IM-4368
    updateView(id) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m;
        // this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'experience').subscribe((beneficiary: WorkDetails[]) => {
        //Check if wizard then get petition level data
        //let getExpApi = this.isWizard ? this.genericBeneficiaryWorkExperienceService.getBeneExperienceInformation(this.primaryData?.visatype,this.primaryData?.caseType,this.primaryData?.caseId,'EXPERIENCE',this.primaryData?.superTaskId,this.primaryData?.subTaskId,true) :this.genericBeneficiaryWorkExperienceService.getBeneficiaryDetails(this.beneficiaryId, 'experience', this.familyId);
        let getExpApi = (this.isWizard && !this.isI140)
            ? this.genericBeneficiaryWorkExperienceService.getBeneExperienceInformation((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.visatype, (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.caseType, (_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.caseId, this.primaryData.caseType == 'I130' ? 'FEXPERIENCE' : 'EXPERIENCE', (_d = this.primaryData) === null || _d === void 0 ? void 0 : _d.superTaskId, (_f = this.primaryData) === null || _f === void 0 ? void 0 : _f.subTaskId, true, (_g = this.primaryData) === null || _g === void 0 ? void 0 : _g.familyId)
            : (this.isI140 && this.isWizard)
                ? (this.primaryData.caseType.toLowerCase() === 'perm'
                    ? this.genericBeneficiaryWorkExperienceService.onGetWorkExperienceDetailsPerm(this.primaryData.caseId, true)
                    : this.genericBeneficiaryWorkExperienceService.getBeneGCExperienceInformation((_h = this.primaryData) === null || _h === void 0 ? void 0 : _h.visatype, (_j = this.primaryData) === null || _j === void 0 ? void 0 : _j.caseType, (_k = this.primaryData) === null || _k === void 0 ? void 0 : _k.caseId, 'experience', (_l = this.primaryData) === null || _l === void 0 ? void 0 : _l.superTaskId, (_m = this.primaryData) === null || _m === void 0 ? void 0 : _m.subTaskId, true))
                : this.genericBeneficiaryWorkExperienceService.getBeneficiaryDetails(this.beneficiaryId, 'experience', this.familyId);
        // IM-4368
        getExpApi.pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary) => {
            beneficiary = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.map((experience) => {
                const clients = [];
                if (experience.clients && experience.clients.length > 0) {
                    experience.clients.forEach(val => {
                        clients.push(val.clientName);
                    });
                }
                return Object.assign(Object.assign({}, experience), { employmentTypeValue: (experience === null || experience === void 0 ? void 0 : experience.employmentType) ? experience.employmentType['name'] : '', 'clientsList': clients.join(','), 'startDate': experience['startDate'] ? moment__default(experience['startDate']).format('DD-MMM-YYYY') : '', 'endDate': experience['endDate'] ? moment__default(experience['endDate']).format('DD-MMM-YYYY') : 'Present' });
            });
            this.hasUnsavedData = false;
            this.dataSource = new MatTableDataSource(beneficiary);
            this.translet();
            this.handleEdit(beneficiary.find(x => x.id === id));
        });
    }
    resetFormToInitial(form) {
        if (form)
            form.reset();
    }
    resetTabs() {
        var _a, _b, _c, _d;
        (_a = this.benExpForm) === null || _a === void 0 ? void 0 : _a.resetForm();
        (_b = this.clientForm) === null || _b === void 0 ? void 0 : _b.resetForm();
        (_c = this.dutiesForm) === null || _c === void 0 ? void 0 : _c.resetForm();
        (_d = this.toolsAndTech) === null || _d === void 0 ? void 0 : _d.resetForm();
        this.selectedTabIndex = 0;
    }
    resetForm() {
        this.experienceFileUploadConfigurations.listUploadedFiles = [];
        this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
        this.beneficiaryWorkDetails = new WorkDetailsLib({});
        this.hasID = false;
        this.isLinear = true;
    }
    closeForm(ngFrm) {
        this.resetForm();
        this.handleClose();
        ngFrm.reset(ngFrm.value);
        this.translet();
    }
    getUpolodedFiles() {
        this.genericBeneficiaryWorkExperienceService.genericGetUploadDocument(this.experienceFileUploadConfigurations.useCase, this.experienceFileUploadConfigurations.useCaseId, this.experienceFileUploadConfigurations.categoryName, this.experienceFileUploadConfigurations.entityId, this.experienceFileUploadConfigurations.useEntityId, this.experienceFileUploadConfigurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response['status'] === 200) {
                this.experienceFileUploadConfigurations.listUploadedFiles = response['data'];
                this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
            }
            else {
                this.experienceFileUploadConfigurations.listUploadedFiles = [];
                this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
            }
        });
    }
    // Save employment
    saveEmployment(benExpForm, isDraft = false, beneficiaryWorkDetailsData) {
        var _a, _b, _c, _d;
        if (beneficiaryWorkDetailsData) {
            this.payload = this.constructPayload(beneficiaryWorkDetailsData, isDraft);
        }
        else {
            this.payload = this.constructPayload(this.beneficiaryWorkDetails, isDraft);
            if (!this.isFormFilled(benExpForm)) {
                this.toastr.warning('Empty records cannot be saved!', 'Warning');
                return;
            }
        }
        // if (!this.isFormFilled(benExpForm)) {
        //   this.toastr.warning('Empty records cannot be saved!', 'Warning');
        //   return;
        // }
        //const reqTobeCalled = this.isWizard ? this.genericBeneficiaryWorkExperienceService.savePetitionWorkExperience(this.primaryData?.caseId,this.payload) : this.genericBeneficiaryWorkExperienceService.saveBeneficiaryDetails(this.beneficiaryId, 'experience', this.payload, this.familyId);
        const reqTobeCalled = (this.isWizard && !this.isI140)
            ? this.genericBeneficiaryWorkExperienceService.savePetitionWorkExperience((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.caseId, this.payload, (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.familyId)
            : (this.isWizard && this.isI140)
                ? this.genericBeneficiaryWorkExperienceService.savePetitionGCWorkExperience((_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.caseId, (_d = this.primaryData) === null || _d === void 0 ? void 0 : _d.caseType, this.payload)
                : this.genericBeneficiaryWorkExperienceService.saveBeneficiaryDetails(this.beneficiaryId, 'experience', this.payload, this.familyId);
        reqTobeCalled.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                if (this.beneficiaryType === 'self') {
                    if (this.customQuestionsComponent) {
                        this.customQuestionsComponent.onClickSave(null);
                    }
                }
                else {
                    if (this.customQuestionsComponent) {
                        this.customQuestionsComponent.onClickSave(this.familyId);
                    }
                }
                if (benExpForm) {
                    benExpForm.reset(benExpForm.value);
                }
                this.toastr.success(response.message, 'Success');
                if (this.isWizard) {
                    this.payload.id = response.data;
                }
                else {
                    this.payload.id = response.data['workExpDetailsReq'][0]['id'];
                }
                this.updateView(this.payload.id);
                this.getBeneficiaryWorkDetails();
                this.hasID = true;
                this.isLinear = false;
            }
        });
        //  this.customTriggeredStatus == false ? this.customTriggeredStatus = true: this.customTriggeredStatus = false;
        this.translet();
    }
    constructPayload(input, isDraft = false) {
        var _a;
        const mainObject = {
            id: input.id || null,
            addressLine1: input.addressLine1 || null,
            addressLine2: input.addressLine2 || null,
            city: input.city || null,
            companyName: input.companyName || null,
            employmentType: input.employmentType ? input.employmentType : null,
            country: input.countryCode || null,
            countryCode: input.countryCode || null,
            currency: input.currency || null,
            designation: input.designation || null,
            isCurrentRole: input.isCurrentRole ? 1 : 0,
            mobileCountryCode: null,
            scheduledWeeklyHours: input === null || input === void 0 ? void 0 : input.scheduledWeeklyHours,
            mobileNo: null,
            officeCountryCode: input.officeCountryCode ? input.officeCountryCode : null,
            officeNo: input.officeNo || null,
            salary: parseInt(input.salary) || null,
            // scheduledWeeklyHours: input.scheduledWeeklyHours,
            startDate: input.startDate ? moment__default(input.startDate).format('YYYY-MM-DD') : null,
            endDate: input.isCurrentRole ? null : (input.endDate ? moment__default(input.endDate).format('YYYY-MM-DD') : null),
            stateProvinceCode: input.stateProvinceCode || null,
            stateProvinceName: input.stateProvinceCode && this.listStates && this.listStates.length > 0 ? (_a = this.listStates.find((x) => x.stateProvinceCode === input.stateProvinceCode)) === null || _a === void 0 ? void 0 : _a.stateProvinceName :
                ((input === null || input === void 0 ? void 0 : input.stateProvinceName) ? input === null || input === void 0 ? void 0 : input.stateProvinceName : null),
            workExpDetailId: input.id || null,
            zipCode: input.zipCode || null,
            duty: input.duty || null,
            subDutyDescription: input.subDutyDescription || null,
            skillName: input.skillName || null,
            jobDuties: input.jobDuties || [],
            tools: input.tools || [],
            clients: input.clients || []
        };
        if (this.isWizard) {
            this.payload = mainObject;
        }
        else {
            this.payload = {
                'workExpDetailsReq': [mainObject],
                isSaveAsDraft: isDraft
            };
        }
        return this.payload;
    }
    callSaveAPI(payload) {
        var _a, _b, _c;
        const saveReq = (this.isWizard && !this.isI140)
            ? this.genericBeneficiaryWorkExperienceService.savePetitionWorkExperience((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.caseId, this.payload)
            : (this.isWizard && this.isI140)
                ? this.genericBeneficiaryWorkExperienceService.savePetitionGCWorkExperience((_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.caseId, (_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.caseType, this.payload)
                : this.genericBeneficiaryWorkExperienceService.saveBeneficiaryDetails(this.beneficiaryId, 'experience', this.payload, this.familyId);
        //const saveReq = this.isWizard ? this.genericBeneficiaryWorkExperienceService.savePetitionWorkExperience(this.primaryData?.caseId,this.payload) : this.genericBeneficiaryWorkExperienceService.saveBeneficiaryDetails(this.beneficiaryId, 'experience', payload, this.familyId);
        saveReq.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response.status === 200) {
                if (!this.isSaveCallFromDel) {
                    this.toastr.success(response.message, 'Success');
                }
                this.isSaveCallFromDel = false;
                if (this.isWizard) {
                    payload.id = response === null || response === void 0 ? void 0 : response.data;
                }
                else {
                    payload.id = response.data && response.data['workExpDetailsReq'][0] && response.data['workExpDetailsReq'][0]['id'];
                }
                this.updateView(payload.id);
            }
        });
    }
    //clientForm: NgForm;
    resetClient(clientForm) {
        clientForm.resetForm();
    }
    addClientDetails(clientForm) {
        if (!this.isFormFilled(clientForm)) {
            this.toastr.warning('Empty records cannot be saved!', 'Warning');
            return;
        }
        // if (this.client.clientName && this.client.startDate) {
        this.beneficiaryWorkDetails.clients.push({
            id: null,
            clientName: this.client.clientName,
            startDate: this.client.startDate ? moment__default(this.client.startDate).format('YYYY-MM-DD') : '',
            endDate: (this.client.endDate) ? moment__default(this.client.endDate).format('YYYY-MM-DD') : ''
        });
        this.payload = this.constructPayload(this.beneficiaryWorkDetails);
        this.callSaveAPI(this.payload);
        this.client.clientName = '';
        this.client.startDate = '';
        this.client.endDate = '';
        clientForm.resetForm(); // clear the form after add the client details
        //}
    }
    removeClientItem(id) {
        let index = this.beneficiaryWorkDetails.clients.findIndex(itm => itm.id === id);
        this.beneficiaryWorkDetails.clients.splice(index, 1);
        this.payload = this.constructPayload(this.beneficiaryWorkDetails);
        this.isSaveCallFromDel = true;
        this.callSaveAPI(this.payload);
    }
    //dutiesForm: NgForm;
    resetJobDuties(dutiesForm) {
        dutiesForm === null || dutiesForm === void 0 ? void 0 : dutiesForm.resetForm();
        this.duty = {
            duty: '',
            dutyId: null,
            sequenceNo: null,
            subDuties: [
                {
                    subDutyDescription: '',
                    subDutyId: null,
                    sequenceNo: null
                }
            ]
        };
        this.translet();
    }
    removeToolsChip(item) {
        const index = this.listToolsTechnology.indexOf(item);
        if (index >= 0) {
            this.listToolsTechnology.splice(index, 1);
        }
    }
    isDutyFormFilled(duty) {
        if (!duty || typeof duty !== 'object')
            return false;
        return Object.entries(duty).some(([key, value]) => {
            if (key === 'dutyId')
                return false;
            if (value === null || value === undefined)
                return false;
            if (typeof value === 'string')
                return value.trim() !== '';
            if (Array.isArray(value))
                return value.some(item => this.isDutyFormFilled(item));
            if (typeof value === 'object')
                return this.isDutyFormFilled(value);
            return !!value;
        });
    }
    addJobDuties(duty) {
        if (!this.isDutyFormFilled(duty)) {
            this.toastr.warning('Empty records cannot be saved!', 'Warning');
            return;
        }
        if (!this.jobEditable) {
            this.beneficiaryWorkDetails.jobDuties.push({
                dutyId: duty && duty.dutyId ? duty.dutyId : null,
                sequenceNo: 0,
                duty: duty.duty,
                subDuties: duty.subDuties,
            });
        }
        this.jobEditable = false;
        this.payload = this.constructPayload(this.beneficiaryWorkDetails);
        this.callSaveAPI(this.payload);
    }
    addSubDuties() {
        this.duty.subDuties.push({
            sequenceNo: null,
            subDutyId: null,
            subDutyDescription: ''
        });
        this.translet();
    }
    deleteSubDuties(index) {
        this.duty.subDuties.splice(index, 1);
    }
    removeJobDuty(id) {
        let index = this.beneficiaryWorkDetails.jobDuties.findIndex(itm => itm.dutyId === id);
        this.beneficiaryWorkDetails.jobDuties.splice(index, 1);
        this.payload = this.constructPayload(this.beneficiaryWorkDetails);
        this.isSaveCallFromDel = true;
        this.callSaveAPI(this.payload);
    }
    editDuty(duty) {
        this.jobEditable = true;
        this.duty = duty;
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.listToolsTechnology.push({
                skillName: value.trim(),
                id: null
            });
        }
        if (input) {
            input.value = '';
        }
    }
    pasteChips(event) {
        event.preventDefault(); //Prevents the default action
        event.clipboardData
            .getData('Text') //Gets the text pasted
            .split(/,/) //Splits it when a SEMICOLON or COMMA or NEWLINE
            .forEach(value => {
            if (value.trim()) {
                this.listToolsTechnology.push({
                    skillName: value.trim(),
                    id: null
                }); //Push if valid
            }
        });
    }
    addToolsTechnologies(toolsAndTech) {
        this.beneficiaryWorkDetails.tools = this.listToolsTechnology.concat(this.beneficiaryWorkDetails.tools);
        this.payload = this.constructPayload(this.beneficiaryWorkDetails);
        this.callSaveAPI(this.payload);
        this.listToolsTechnology = [];
        toolsAndTech.reset(toolsAndTech.value);
        this.toolsAndTechChip = '';
    }
    removeToolsTechnology(id) {
        let index = this.beneficiaryWorkDetails.tools.findIndex(itm => itm.id === id);
        this.beneficiaryWorkDetails.tools.splice(index, 1);
        this.payload = this.constructPayload(this.beneficiaryWorkDetails);
        this.isSaveCallFromDel = true;
        this.callSaveAPI(this.payload);
    }
    handleEdit(input) {
        var _a;
        this.beneficiaryWorkDetails = {
            id: input.id,
            addressLine1: input.addressLine1,
            addressLine2: input.addressLine2,
            city: input.city,
            companyName: input.companyName,
            scheduledWeeklyHours: input.scheduledWeeklyHours,
            employmentType: input.employmentType ? input.employmentType.code : null,
            country: input.countryCode,
            countryCode: input.countryCode,
            currency: input.currency,
            designation: input.designation,
            isCurrentRole: input.isCurrentRole == 1 ? true : false,
            mobileCountryCode: null,
            mobileNo: null,
            //officeCountryCode: this.isWizard ? input.officeCountryCode : (input.officeCountryCode && input.officeCountryCode.countryCode ? input.officeCountryCode.countryCode : ''),
            officeCountryCode: this.isWizard ? input.officeCountryCode || '' : ((_a = input.officeCountryCode) === null || _a === void 0 ? void 0 : _a.countryCode) || '',
            officeNo: this.isWizard ? input.employerOfficeNo : input.officeNo,
            salary: input.salary,
            startDate: moment__default(input.startDate).toISOString(),
            endDate: input.isCurrentRole == 1 ? null : moment__default(input.endDate).toISOString(),
            stateProvinceCode: input.stateProvinceCode,
            stateProvinceName: input.stateProvinceCode,
            workExpDetailId: input.id,
            zipCode: input.zipCode,
            duty: input.duty,
            subDutyDescription: input.subDutyDescription,
            skillName: input.skillName,
            jobDuties: input.jobDuties,
            tools: input.tools,
            clients: input.clients,
            documentList: input.documents
        };
        this.translet();
        this.hasID = true;
        this.isLinear = false;
        this.experienceFileUploadConfigurations.entityId = input.id;
        this.experienceFileUploadConfigurations.useCaseId = this.beneficiaryId;
        this.experienceFileUploadConfigurations.familyId = this.familyId ? this.familyId : null;
        // this.listToolsTechnology = input.tools;
        this.experienceFileUploadConfigurations.listUploadedFiles = input.documents ? input.documents : [];
        this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
        this.changeDetector.markForCheck();
        this.expandPanel = true;
        // this.handleCountryChange(input.countryCode);
        this.genericBeneficiaryWorkExperienceService.getStates(input.countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states) => {
            this.referenceLibraryService.translateArray(states, 'stateProvinceName')
                .then(translated => {
                var _a, _b;
                this.listStates = translated;
                this.beneficiaryWorkDetails.stateProvinceName = input.stateProvinceCode ?
                    this.listStates.find((x) => x.stateProvinceCode === input.stateProvinceCode).stateProvinceName : (input.stateProvinceName ? input.stateProvinceName : null);
                this.beneficiaryWorkDetails = {
                    id: input.id,
                    addressLine1: input.addressLine1,
                    addressLine2: input.addressLine2,
                    city: input.city,
                    companyName: input.companyName,
                    scheduledWeeklyHours: input.scheduledWeeklyHours,
                    employmentType: input.employmentType ? input.employmentType.code : null,
                    country: input.countryCode,
                    countryCode: input.countryCode,
                    currency: input.currency,
                    designation: input.designation,
                    isCurrentRole: input.isCurrentRole == 1 ? true : false,
                    mobileCountryCode: null,
                    mobileNo: null,
                    //officeCountryCode: input.officeCountryCode && input.officeCountryCode.countryCode ? input.officeCountryCode.countryCode : '',
                    officeCountryCode: this.isWizard ? input.officeCountryCode || '' : ((_a = input.officeCountryCode) === null || _a === void 0 ? void 0 : _a.countryCode) || '',
                    officeNo: this.isWizard ? input.employerOfficeNo : input.officeNo,
                    salary: input.salary,
                    startDate: moment__default(input.startDate).toISOString(),
                    endDate: input.isCurrentRole == 1 ? null : moment__default(input.endDate).toISOString(),
                    stateProvinceCode: input.stateProvinceCode,
                    stateProvinceName: input.stateProvinceCode ?
                        this.listStates.find((x) => x.stateProvinceCode === input.stateProvinceCode).stateProvinceName :
                        (input.stateProvinceName ? input.stateProvinceName : null),
                    workExpDetailId: input.id,
                    zipCode: input.zipCode,
                    duty: input.duty,
                    subDutyDescription: input.subDutyDescription,
                    skillName: input.skillName,
                    jobDuties: input.jobDuties,
                    tools: input.tools,
                    clients: input.clients,
                    documentList: input.documents
                };
                this.hasID = true;
                this.isLinear = false;
                this.experienceFileUploadConfigurations.entityId = input.id;
                if (this.isWizard) {
                    'petition';
                }
                this.experienceFileUploadConfigurations.useCase = this.isWizard ? 'petition' : 'beneficiary';
                this.experienceFileUploadConfigurations.useCaseId = this.isWizard ? (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.caseId : this.beneficiaryId;
                this.experienceFileUploadConfigurations.familyId = this.familyId ? this.familyId : null;
                // this.listToolsTechnology = input.tools;
                this.experienceFileUploadConfigurations.listUploadedFiles = input.documents ? input.documents : [];
                this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
                this.changeDetector.markForCheck();
            })
                .catch(error => console.error("Translation error:", error));
        });
    }
    toggleExpansion() {
        this.expandPanel = !this.expandPanel;
        this.resetForm();
        this.hasID = false;
        this.isLinear = true;
    }
    toggleListView(val) {
        if (!val) {
            this.isTimeLineView = true;
            this.isListView = false;
        }
        else {
            this.isTimeLineView = false;
            this.isListView = true;
        }
    }
    isFormFilled(form) {
        return form && form.controls
            ? Object.entries(form.controls).some(([key, control]) => {
                if (key === 'isCurrentRole')
                    return false;
                const value = control.value;
                return value !== null && value !== undefined && (typeof value === 'string' ? value.trim() !== '' : !!value);
            })
            : false;
    }
    handleCountryChange(countryCode) {
        if (null === countryCode) {
            this.listStates = [];
            this.beneficiaryWorkDetails['stateProvinceCode'] = null;
            this.beneficiaryWorkDetails['stateProvinceName'] = null;
            return;
        }
        this.genericBeneficiaryWorkExperienceService.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states) => {
            this.referenceLibraryService.translateArray(states, 'stateProvinceName')
                .then(translated => {
                this.listStates = translated;
                if (this.listStates.length) {
                    this.beneficiaryWorkDetails['stateProvinceCode'] = null;
                }
                else {
                    this.beneficiaryWorkDetails['stateProvinceName'] = null;
                }
                this.changeDetector.markForCheck();
            })
                .catch(error => console.error("Translation error:", error));
        });
    }
    handleDeleteExperience(input) {
        const title = 'Confirm';
        const message = 'Do you wish to remove this item?';
        this.dialogueInitializer(event, title, message).afterClosed().subscribe(result => {
            var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l;
            if (result) {
                const deleteReq = (this.isWizard && !this.isI140) ?
                    this.genericBeneficiaryWorkExperienceService.deletBeneWorkExperience((_a = this.primaryData) === null || _a === void 0 ? void 0 : _a.visatype, (_b = this.primaryData) === null || _b === void 0 ? void 0 : _b.caseType, (_c = this.primaryData) === null || _c === void 0 ? void 0 : _c.caseId, 'EXPERIENCE', (_d = this.primaryData) === null || _d === void 0 ? void 0 : _d.superTaskId, (_f = this.primaryData) === null || _f === void 0 ? void 0 : _f.subTaskId, input.id)
                    : (this.isI140 && this.isWizard)
                        ? this.genericBeneficiaryWorkExperienceService.deletBeneGCWorkExperience((_g = this.primaryData) === null || _g === void 0 ? void 0 : _g.visatype, (_h = this.primaryData) === null || _h === void 0 ? void 0 : _h.caseType, (_j = this.primaryData) === null || _j === void 0 ? void 0 : _j.caseId, 'experience', (_k = this.primaryData) === null || _k === void 0 ? void 0 : _k.superTaskId, (_l = this.primaryData) === null || _l === void 0 ? void 0 : _l.subTaskId, input.id)
                        : this.genericBeneficiaryWorkExperienceService.deleteBeneExperience(this.beneficiaryId, input.id, this.familyId);
                deleteReq.pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                    if (data.status === 200) {
                        if (this.beneficiaryWorkDetails.id === input.id) {
                            this.resetForm();
                        }
                        this.toastr.success(data.message, 'Success');
                        this.getBeneficiaryWorkDetails();
                    }
                });
            }
        });
    }
    fileUploadSuccess() {
        this.getBeneficiaryWorkDetails(); // Relaod main table
    }
    handleEmploymentTypeChange(val, benExpForm) {
        // console.log("$$$$$$$",val,benExpForm);
        benExpForm.form.get('currency').clearValidators();
        benExpForm.form.get('salary').clearValidators();
        // if (val !== 'SELF') {
        //   benExpForm.form.get('currency').setValidators([Validators.required]);
        //   benExpForm.form.get('salary').setValidators([Validators.required]);
        // } else {
        //   benExpForm.form.get('currency').clearValidators();
        //   benExpForm.form.get('salary').clearValidators();
        // }
        benExpForm.form.get('currency').updateValueAndValidity();
        benExpForm.form.get('salary').updateValueAndValidity();
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    dialogueInitializer(event, title, message) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent$1, {
            width: '400px',
            data: {
                update: { title, message },
                buttons: ['Cancel', 'Delete']
            }
        });
        return dialogRef;
    }
    onRefreshPage(event) {
        if (event) {
            setTimeout(() => {
                this.ngOnInit();
            }, 600);
        }
    }
    handleClose() {
        this.showTabs = false;
        this.translet();
    }
    tabChange() {
        this.translet();
    }
    handleShowTabs() {
        this.showTabs = true;
        this.resetForm();
        this.hasID = false;
        this.isLinear = true;
        this.changeDetector.detectChanges();
        this.translet();
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o;
        if ((_a = changes === null || changes === void 0 ? void 0 : changes.mode) === null || _a === void 0 ? void 0 : _a.currentValue) {
            if (((_b = changes === null || changes === void 0 ? void 0 : changes.mode) === null || _b === void 0 ? void 0 : _b.currentValue) === 'list') {
                this.modeVal = true;
            }
        }
        if (((changes === null || changes === void 0 ? void 0 : changes.caseRequestShowDivs) && (changes === null || changes === void 0 ? void 0 : changes.caseRequestShowDivs.currentValue)) || ((changes === null || changes === void 0 ? void 0 : changes.benQuestShowDivs) && ((_c = changes === null || changes === void 0 ? void 0 : changes.benQuestShowDivs) === null || _c === void 0 ? void 0 : _c.currentValue))) {
            if ((changes === null || changes === void 0 ? void 0 : changes.caseRequestShowDivs) && ((_d = changes === null || changes === void 0 ? void 0 : changes.caseRequestShowDivs) === null || _d === void 0 ? void 0 : _d.currentValue)) {
                this.iscaseRequest = true;
                (_g = (_f = changes === null || changes === void 0 ? void 0 : changes.caseRequestShowDivs) === null || _f === void 0 ? void 0 : _f.currentValue) === null || _g === void 0 ? void 0 : _g.subLevel.forEach(element => {
                    this.currentItemDisplay.push(element.code);
                });
            }
            if ((changes === null || changes === void 0 ? void 0 : changes.benQuestShowDivs) && ((_h = changes === null || changes === void 0 ? void 0 : changes.benQuestShowDivs) === null || _h === void 0 ? void 0 : _h.currentValue)) {
                this.isBenQuestShowDivs = true;
                (_k = (_j = changes === null || changes === void 0 ? void 0 : changes.benQuestShowDivs) === null || _j === void 0 ? void 0 : _j.currentValue) === null || _k === void 0 ? void 0 : _k.subLevel.forEach(element => {
                    this.currentItemDisplay.push(element.code);
                });
            }
        }
        else {
            this.iscaseRequest = false;
        }
        // console.log('this.currentItemDisplay', this.currentItemDisplay);
        if ((_l = changes === null || changes === void 0 ? void 0 : changes.formDetails) === null || _l === void 0 ? void 0 : _l.currentValue) {
            if (this.documentType == 'RESUME') {
                this.parsedJsonData = changes.formDetails.currentValue;
                if (Array.isArray((_o = (_m = this.parsedJsonData) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.experience) && this.parsedJsonData.data.experience.length) {
                    if (Array.isArray(this.dataSource) && this.dataSource.length) {
                        let deleteReqArray = [];
                        this.dataSource.forEach(element => {
                            var _a;
                            deleteReqArray.push(this.apiService.deletBeneWorkExperience((_a = this.primaryData.visaType) !== null && _a !== void 0 ? _a : this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, 'experience', this.primaryData.superTaskId, this.primaryData.subTaskId, element.id));
                        });
                        combineLatest([...deleteReqArray])
                            .pipe(take(1))
                            .subscribe(data => {
                            this.toastr.success('Deleted experience details successfully!', 'Success');
                            this.resetForm();
                            this.getBeneficiaryWorkDetails();
                            this.addExportedDate();
                        });
                    }
                    else {
                        this.addExportedDate();
                    }
                }
            }
        }
    }
    addExportedDate() {
        this.parsedJsonData.data.experience.forEach((exp, index) => {
            var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
            this.beneficiaryWorkDetails = {
                id: (_a = exp.id) !== null && _a !== void 0 ? _a : null,
                addressLine1: (_b = exp.addressLine1) !== null && _b !== void 0 ? _b : null,
                addressLine2: (_c = exp.addressLine2) !== null && _c !== void 0 ? _c : null,
                city: (_d = exp.city) !== null && _d !== void 0 ? _d : null,
                companyName: (_f = exp.companyName) !== null && _f !== void 0 ? _f : null,
                employmentType: (_h = (_g = exp.employmentType) === null || _g === void 0 ? void 0 : _g.code) !== null && _h !== void 0 ? _h : null,
                country: (_j = exp.countryCode) !== null && _j !== void 0 ? _j : null,
                countryCode: (_k = exp.countryCode) !== null && _k !== void 0 ? _k : null,
                currency: (_l = exp.currency) !== null && _l !== void 0 ? _l : null,
                designation: (_m = exp.designation) !== null && _m !== void 0 ? _m : null,
                isCurrentRole: exp.isCurrentRole === 1,
                mobileCountryCode: null,
                mobileNo: null,
                officeCountryCode: (_p = (_o = exp.officeCountryCode) === null || _o === void 0 ? void 0 : _o.countryCode) !== null && _p !== void 0 ? _p : null,
                officeNo: (_q = exp.officeNo) !== null && _q !== void 0 ? _q : null,
                salary: (_r = exp.salary) !== null && _r !== void 0 ? _r : null,
                startDate: this.appServicesLibraryService.parseToISOString(exp.startDate),
                endDate: exp.isCurrentRole === 1 ? null : this.appServicesLibraryService.parseToISOString(exp.endDate),
                stateProvinceCode: (_s = exp.stateProvinceCode) !== null && _s !== void 0 ? _s : null,
                stateProvinceName: exp.stateProvinceCode
                    ? (_u = (_t = this.listStates.find((x) => x.stateProvinceCode === exp.stateProvinceCode)) === null || _t === void 0 ? void 0 : _t.stateProvinceName) !== null && _u !== void 0 ? _u : null : (_v = exp.stateProvinceName) !== null && _v !== void 0 ? _v : null,
                workExpDetailId: (_w = exp.id) !== null && _w !== void 0 ? _w : null,
                zipCode: (_x = exp.zipCode) !== null && _x !== void 0 ? _x : null,
                duty: (_y = exp.duty) !== null && _y !== void 0 ? _y : null,
                subDutyDescription: (_z = exp.subDutyDescription) !== null && _z !== void 0 ? _z : null,
                skillName: (_0 = exp.skillName) !== null && _0 !== void 0 ? _0 : null,
                jobDuties: (_1 = exp.jobDuties) !== null && _1 !== void 0 ? _1 : null,
                tools: (_2 = exp.tools) !== null && _2 !== void 0 ? _2 : null,
                clients: (_3 = exp.clients) !== null && _3 !== void 0 ? _3 : null,
                documentList: (_4 = exp.documents) !== null && _4 !== void 0 ? _4 : [],
                scheduledWeeklyHours: (_5 = exp === null || exp === void 0 ? void 0 : exp.scheduledWeeklyHours) !== null && _5 !== void 0 ? _5 : null
            };
            this.saveEmployment(this.benExpForm, false, this.beneficiaryWorkDetails);
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.genericBeneficiaryWorkExperienceService.onUnSubscribe(this.subscriptions);
        if (this.genericBeneficiaryWorkExperienceService.formChangesSubscription) {
            this.genericBeneficiaryWorkExperienceService.formChangesSubscription.unsubscribe();
        }
        if (this.dependentIdSubscription) {
            this.dependentIdSubscription.unsubscribe();
        }
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
}
GenericBeneficiaryWorkExperienceComponent.ɵfac = function GenericBeneficiaryWorkExperienceComponent_Factory(t) { return new (t || GenericBeneficiaryWorkExperienceComponent)(i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i2$2.ToastrService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i5$1.CacheCountryListService), i0.ɵɵdirectiveInject(i2$1.Store), i0.ɵɵdirectiveInject(DependentProfileDataService), i0.ɵɵdirectiveInject(i8.AppServicesLibraryService), i0.ɵɵdirectiveInject(GenericBeneficiaryWorkExperienceService), i0.ɵɵdirectiveInject(i10.DirtyFormGuard)); };
GenericBeneficiaryWorkExperienceComponent.ɵcmp = i0.ɵɵdefineComponent({ type: GenericBeneficiaryWorkExperienceComponent, selectors: [["lib-generic-beneficiary-work-experience"]], viewQuery: function GenericBeneficiaryWorkExperienceComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 3);
        i0.ɵɵviewQuery(_c1$1, 1);
        i0.ɵɵviewQuery(CustomQuestionnaireComponent, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.item = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.benExpForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customQuestionsComponent = _t.first);
    } }, inputs: { mode: "mode", showLifeStoryTimeLineSection: "showLifeStoryTimeLineSection", isViewMode: "isViewMode", caseRequestShowDivs: "caseRequestShowDivs", benQuestShowDivs: "benQuestShowDivs", primaryData: "primaryData", isI140: "isI140", isTimeLine: "isTimeLine", formDetails: "formDetails", documentType: "documentType", familyId: "familyId", isWizard: "isWizard" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "row", "mt-4", 3, "hidden"], ["mat-table", "", "multiTemplateDataRows", "", 1, "experience-list-table", "w-100", "mb-0", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["matColumnDef", "expandedDetail"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], ["class", "mat-row", 4, "matNoDataRow"], [3, "ngClass"], [1, "row", "d-flex", "justify-content-end", 3, "ngClass"], ["class", "btn btn-primary mb-2", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-primary", "mb-2", 3, "click"], ["id", "expAddBtn", 1, "common-bene-class-for-translation"], ["class", "mt-4 work-experience-component", 4, "ngIf"], [1, "mt-4", "work-experience-component"], [1, "p-col-12", "text-right", "align-middle"], [1, "close-icon", "pi", "pi-times", 3, "click"], [3, "selectedTabChange"], ["matTabLabel", ""], ["matTabContent", ""], [3, "disabled"], ["class", "w-100", 3, "ngClass", 4, "ngIf"], [1, "row"], [1, "col-12", "text-right"], ["type", "button", "class", "back-button mr-3", 3, "click", 4, "ngIf"], [1, "formBox"], ["id", "dutyListLbl", 1, "labelText", "common-bene-class-for-translation"], ["class", "w-100", 3, "ngClass", "ngSubmit", 4, "ngIf"], ["class", "back-button mr-3", 3, "click", 4, "ngIf"], [1, "formBox", 3, "ngClass"], [1, "labelText"], [1, "common-bene-class-for-translation"], [1, "row", "mb-10"], ["class", "w-100 list-of-tools-and-technologies", 4, "ngIf"], ["class", "formBox", 3, "ngClass", 4, "ngIf"], ["id", "employementTab", 1, "common-bene-class-for-translation"], [1, "row", "formBox"], [1, "w-100", 3, "ngClass"], ["benExpForm", "ngForm"], ["class", "row mt-4", 4, "ngIf"], ["class", "form-group col-md-8", 4, "ngIf"], ["class", "form-group col-md-4", 4, "ngIf"], [1, "col-md-4"], ["id", "weeklyHoursLbl", 1, "label-cls", "common-bene-class-for-translation"], ["name", "scheduledWeeklyHours", "placeholder", "Enter Weekly Hour", "type", "number", 1, "im-input", "mb-2", "col", "phoneInput", "mt-0", 3, "ngModel", "ngModelChange"], ["salary", "ngModel"], [1, "col-12"], [1, "position-relative"], ["class", "labelText mt-3 ml-3 common-bene-class-for-translation", "id", "empContactDetailsLbl", 4, "ngIf"], ["class", "form-group col-md-6", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "next-btn"], [1, "d-flex", "flex-row-reverse"], ["class", "p-2", 4, "ngIf"], [1, "p-2"], ["class", "btn btn-success", 3, "click", 4, "ngIf"], [1, "row", "mt-4"], [1, "form-group", "col-md-12"], ["name", "isCurrentRole", 3, "ngModel", "ngModelChange"], ["id", "expCurrentCheck", 1, "common-bene-class-for-translation"], [1, "form-group", "col-md-8"], ["id", "expTitleLbl", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "designation", "placeholder", "Enter", 1, "im-input", "mb-2", "mw-100", 3, "ngModel", "ngModelChange"], ["designation", "ngModel"], [1, "form-group", "col-md-4"], ["id", "empTypeLbl", 1, "label-cls", "common-bene-class-for-translation"], ["name", "employmentType", "styleClass", "bene-we-dropdown mt-1", "optionValue", "code", "optionLabel", "name", "placeholder", "Select Type", 1, "label-cls", 3, "options", "ngModel", "onChange", "ngModelChange"], ["employmentTy", "ngModel"], ["pTemplate", "item"], ["id", "empTypeDd_1", 1, "common-bene-class-for-translation"], ["id", "empTypeDd_2", 1, "common-bene-class-for-translation"], ["id", "employedFromLbl_1", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-0", "date-field", 2, "display", "inline !important"], ["matInput", "", "name", "startDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "ngModel", "max", "ngModelChange", "click"], ["startDt", "ngModel"], ["matSuffix", "", 3, "for"], ["employedFromPicker", ""], ["id", "employedFromLbl_2", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["id", "employedTillLbl_1", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["matInput", "", "name", "endDate", "placeholder", "MM/DD/YYYY", 3, "matDatepicker", "ngModel", "min", "max", "ngModelChange", "click"], ["employedTillPicker", ""], ["id", "employedTillLbl_2", 1, "label-cls", "d-block", "common-bene-class-for-translation"], ["id", "expSalaryLbl", 1, "label-cls", "common-bene-class-for-translation"], ["name", "currency", "styleClass", "bene-we-dropdown currency-dropdown", "optionValue", "id", "optionLabel", "name", "placeholder", "Select", 3, "options", "ngModel", "ngModelChange"], ["currency", "ngModel"], ["name", "salary", "placeholder", "Enter", "type", "number", 1, "im-input", "mb-2", "col", "phoneInput", "mt-0", 3, "ngModel", "ngModelChange"], ["id", "currencyDd", 1, "common-bene-class-for-translation"], ["id", "empContactDetailsLbl", 1, "labelText", "mt-3", "ml-3", "common-bene-class-for-translation"], [1, "form-group", "col-md-6"], ["id", "companyDetailsLbl_1", 1, "label-cls", "common-bene-class-for-translation"], ["id", "empCompanyName", "type", "text", "name", "companyName", "placeholder", "Enter", 1, "im-input", "mb-2", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["companyName", "ngModel"], ["id", "companyDetailsLbl_2", 1, "label-cls", "common-bene-class-for-translation"], ["id", "ofcNoLbl_1", 1, "label-cls", "common-bene-class-for-translation"], ["name", "officeCountryCode", "styleClass", "bene-we-dropdown country-code-dropdown", "optionValue", "countryCode", "optionLabel", "labelWithCode", "placeholder", "Select", "filterBy", "countryName", 1, "mt-1", 3, "options", "ngModel", "filter", "ngModelChange"], ["name", "officeNo", "pattern", "[0-9]{8,10}", "type", "text", "form", "", "placeholder", "Office", "maxlength", "10", 1, "im-input", "mb-2", "col", "phoneInput", 3, "ngModel", "ngModelChange"], ["officeNo", "ngModel"], ["class", "invalid-message common-bene-class-for-translation", 4, "ngIf"], [1, "invalid-message", "common-bene-class-for-translation"], ["id", "empAddrOneLbl", 1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "name", "addressLine1", "placeholder", "Address Line 1", 1, "im-input", "mb-2", "mw-100", 3, "ngModel", "ngModelChange"], ["addressLine1", "ngModel"], ["id", "empAddrOne", "type", "text", "name", "addressLine1", "placeholder", "Address Line 1", 1, "im-input", "mb-2", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["id", "empAddrTwoLbl", 1, "label-cls", "common-bene-class-for-translation"], ["id", "empAddrTwo", "type", "text", "name", "addressLine2", "placeholder", "Address Line 1", 1, "im-input", "mb-2", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["id", "empCountryLbl_1", 1, "label-cls", "common-bene-class-for-translation"], ["name", "country", "styleClass", "bene-we-dropdown mt-1", "optionValue", "countryCode", "optionLabel", "countryName", "placeholder", "Select", "filterBy", "countryName", 1, "label-cls", 3, "options", "ngModel", "filter", "onChange", "ngModelChange"], ["country", "ngModel"], ["id", "empCityLbl_6", 1, "label-cls", "common-bene-class-for-translation"], ["id", "empCity", "name", "city", "type", "text", "placeholder", "City", 1, "im-input", "mb-2", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["city", "ngModel"], ["id", "empCountry", 1, "common-bene-class-for-translation"], ["id", "empStateLbl_1", 1, "label-cls", "common-bene-class-for-translation"], ["name", "stateProvinceCode", "styleClass", "bene-we-dropdown mt-1", "optionValue", "stateProvinceCode", "optionLabel", "stateProvinceName", "placeholder", "Select State", "filterBy", "stateProvinceName", 3, "options", "ngModel", "filter", "ngModelChange"], ["stateProvinceDropdown", "ngModel"], ["id", "empState", 1, "common-bene-class-for-translation"], ["id", "empStateLbl_2", 1, "label-cls", "common-bene-class-for-translation"], ["id", "empState", "name", "stateProviceName", "type", "text", "placeholder", "State", 1, "im-input", "mb-2", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["stateProviceName", "ngModel"], ["id", "empCountryLbl_2", 1, "label-cls", "common-bene-class-for-translation"], ["name", "country", "styleClass", "bene-we-dropdown", "optionValue", "countryCode", "optionLabel", "countryName", "placeholder", "Select Country", 3, "options", "ngModel", "onChange", "ngModelChange"], ["id", "empCityLbl_5", 1, "label-cls", "common-bene-class-for-translation"], ["id", "empCountry__122", 1, "common-bene-class-for-translation"], ["id", "empStateLbl_3", 1, "label-cls", "common-bene-class-for-translation"], ["name", "stateProvinceCode", "styleClass", "bene-we-dropdown", "optionValue", "stateProvinceCode", "optionLabel", "stateProvinceName", "placeholder", "Select State", 3, "options", "ngModel", "ngModelChange"], ["id", "empStateLbl_4", 1, "label-cls", "common-bene-class-for-translation"], ["id", "empZipCodeLbl", 1, "label-cls", "common-bene-class-for-translation"], ["name", "zipCode", "maxlength", "10", "type", "text", "placeholder", "Zip Code", "pattern", "^$|^[A-Za-z0-9]+", 1, "im-input", "mb-2", "mw-100", 3, "ngClass", "ngModel", "ngModelChange"], ["zipCode", "ngModel"], ["class", "invalid-message common-bene-class-for-translation", "id", "zipErrMsg", 4, "ngIf"], ["id", "zipErrMsg", 1, "invalid-message", "common-bene-class-for-translation"], ["name", "zipCode", "maxlength", "10", "type", "text", "placeholder", "Zip Code", 1, "im-input", "mb-2", "mw-100", 3, "ngModel", "ngModelChange"], [4, "ngFor", "ngForOf"], ["class", "customSections", 4, "ngFor", "ngForOf"], [1, "customSections"], [3, "isNewPortion", "viewQuestions", "loadedIn", "beneficiaryId", "isSection", "familyId", "refreshList"], ["type", "button", 1, "back-button", 3, "click"], ["id", "empCloseBtn", 1, "common-bene-class-for-translation"], [1, "btn", "btn-success", 3, "click"], ["id", "empSaveBtn", 1, "common-bene-class-for-translation"], ["id", "clientsTab", 1, "common-bene-class-for-translation"], ["clientForm", "ngForm"], [1, "beneficiary-workexp-clients-box"], ["id", "clientsWorkedLbl", 1, "mt-4", "mb-2", "labelText", "common-bene-class-for-translation"], [1, "form-group", "col-md-8", "mt-2"], ["id", "clientNameLbl", 1, "label-cls", "common-bene-class-for-translation"], ["id", "clientNameInput", "type", "text", "name", "clientName", "placeholder", "Enter", 1, "im-input", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["clientName", "ngModel"], [1, "row", "align-items-end"], ["id", "clientStartDateLbl", 1, "label-cls", "common-bene-class-for-translation"], ["appearance", "outline", 1, "mt-0", "date-field"], ["name", "clientStartDt", "matInput", "", "placeholder", "MM/DD/YYYY", 3, "ngModel", "min", "max", "matDatepicker", "ngModelChange", "click"], ["clientStartDt", "ngModel"], [3, "startAt"], ["clientStartDate", ""], ["class", "label-cls common-bene-class-for-translation", "id", "clientEndDateLbl", 4, "ngIf"], ["class", "label-cls mb-1 common-bene-class-for-translation", "id", "clientEndDateLbl", 4, "ngIf"], ["name", "clientEndDt", "matInput", "", "placeholder", "MM/DD/YYYY", 3, "ngModel", "matDatepicker", "min", "max", "ngModelChange", "click"], ["clientEndDt", "ngModel"], ["clientEndDate", ""], [1, "client-display-box", "col-md-12"], ["class", "client-list-print", 4, "ngIf"], ["id", "clientEndDateLbl", 1, "label-cls", "common-bene-class-for-translation"], ["id", "clientEndDateLbl", 1, "label-cls", "mb-1", "common-bene-class-for-translation"], ["id", "addClientBtn", 1, "common-bene-class-for-translation"], [1, "client-list-print"], ["id", "clientsAddedHdr", "mat-subheader", "", 1, "mat-subheader-clients-added", "common-bene-class-for-translation"], [1, "clients-list-item-partition"], ["id", "clientNameCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["id", "clientFromCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["id", "clientToCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["id", "clientActionCol", "mat-line", "", 1, "common-bene-class-for-translation"], [3, "ngClass", 4, "ngFor", "ngForOf"], [1, "numberCircle", "float-left", "mr-1", "ml-n1"], ["mat-line", "", 1, "mt-2", "common-bene-class-for-translation", 3, "id"], ["mat-line", ""], ["class", "delete-client-entry", 3, "click", 4, "ngIf"], [1, "delete-client-entry", 3, "click"], ["type", "button", 1, "back-button", "mr-3", 3, "click"], ["id", "clientCloseBtn", 1, "common-bene-class-for-translation"], ["id", "listOfDutiesTab", 1, "common-bene-class-for-translation"], [1, "w-100", 3, "ngClass", "ngSubmit"], ["dutiesForm", "ngForm"], [1, "row", "mt-2"], [1, "col-md-12", "mt-2"], ["id", "dutyLbl", 1, "labelText", "common-bene-class-for-translation"], ["id", "dutyInput", "name", "duty", "type", "text", "placeholder", "Please enter Duty", 1, "im-input", "mb-4", "mw-100", "common-bene-class-for-translation", 3, "ngModel", "ngModelChange"], ["mainDuty", "ngModel"], ["class", "row", 4, "ngFor", "ngForOf"], ["type", "button", 1, "im-btn", "im-btn-primary", "im-btn-md", 2, "margin-top", "30px", 3, "disabled", "click"], ["id", "dutiesAddBtn", 1, "common-bene-class-for-translation"], [1, "col-md-10"], [1, "form-group"], ["id", "subDutyInput", "type", "text", "placeholder", "Ex: Lead Team", 1, "im-input", "mb-4", "common-bene-class-for-translation", 3, "name", "ngModel", "ngModelChange"], [1, "form-group", "col-md-1", "mt-4", "pt-2"], ["aria-hidden", "false", "class", "icn-delete pl-2", 3, "click", 4, "ngIf"], ["class", "form-group col-md-1 mt-4 pt-2", 4, "ngIf"], ["aria-hidden", "false", 1, "icn-delete", "pl-2", 3, "click"], ["matTooltip", "Add new sub duty", "aria-hidden", "false", 1, "icn-add", 3, "click"], ["id", "dutiesAddedHdr", "mat-subheader", "", 1, "mat-subheader-clients-added", "common-bene-class-for-translation"], [1, "duties-list"], ["id", "dutyCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["id", "subDutyCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["id", "dutiesActionCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["class", "duties-list", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "duties-list", 3, "ngClass"], ["mat-line", "", "class", "mt-2", 4, "ngFor", "ngForOf"], [3, "click", 4, "ngIf"], ["mat-line", "", 1, "mt-2"], [1, "common-bene-class-for-translation", 2, "margin-left", "5px", "word-break", "break-word", "white-space", "normal !important", 3, "id"], [3, "click"], [1, "back-button", "mr-3", 3, "click"], ["id", "dutiesCloseBtn", 1, "common-bene-class-for-translation"], [1, "w-100", "list-of-tools-and-technologies"], ["toolsAndTech", "ngForm"], ["appearance", "outline", 1, "example-chip-list", "col", "chips-contianer"], ["aria-label", "Tools selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["id", "toolsChipText", "placeholder", "Eg: JavaScript...", "name", "toolsAndTechChip", 1, "common-bene-class-for-translation", 3, "matChipInputFor", "ngModel", "matChipInputSeparatorKeyCodes", "matChipInputAddOnBlur", "ngModelChange", "paste", "matChipInputTokenEnd"], ["tlsAdTechChip", "ngModel"], ["id", "commaSeperatedText", 1, "hint-text", "mt-2", "pl-2", "common-bene-class-for-translation"], [1, "form-group", "col-2", "mt-2", "pt-3"], ["type", "button", 1, "im-btn", "im-btn-primary", "im-btn-md", 3, "disabled", "click"], ["id", "toolsAndTechAddBtn", 1, "common-bene-class-for-translation"], [3, "selectable", "removable", "removed"], [1, "common-bene-class-for-translation", 3, "id"], ["matTooltip", "Remove this item", "matChipRemove", "", 4, "ngIf"], ["matTooltip", "Remove this item", "matChipRemove", ""], ["id", "addedTooldandTechLbl", "mat-subheader", "", 1, "mat-subheader-clients-added"], ["id", "toolsAndTechCol", "mat-line", ""], ["id", "toolsActionCol", "mat-line", "", 1, "common-bene-class-for-translation"], ["id", "toolsAndTechCloseBtn", 1, "common-bene-class-for-translation"], ["id", "uploadDocsTab", 1, "common-bene-class-for-translation"], ["id", "docSelectLbl", 1, "common-bene-class-for-translation"], [1, "w-100"], ["docUploadForm", "ngForm"], [1, "w-100", 3, "isWizard", "primaryData", "configurations", "fileUploadSuccess"], ["id", "docCloseBtn", 1, "common-bene-class-for-translation"], [3, "matColumnDef"], ["class", "common-bene-class-for-translation", "mat-header-cell", "", "mat-sort-header", "", 3, "id", 4, "matHeaderCellDef"], ["mat-header-cell", "", "mat-sort-header", "", 1, "common-bene-class-for-translation", 3, "id"], ["mat-cell", ""], ["class", "toggle-col", 4, "ngIf"], ["class", "common-bene-class-for-translation", 3, "id", 4, "ngIf"], [1, "toggle-col"], ["matTooltip", "View more", 1, "mr-1", "icn", 3, "click"], ["class", "column.customClass", 4, "ngIf"], [1, "column.customClass"], [1, "d-block", "w-max-content"], ["class", "mr-1 icn", "matTooltip", "Edit", "class", "im-table-verticle-icon", 3, "click", 4, "ngIf"], ["class", "mr-1 icn", "matTooltip", "Delete", 3, "click", 4, "ngIf"], ["matTooltip", "Edit", 1, "im-table-verticle-icon", 3, "click"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], ["class", "example-element-detail", 4, "ngIf"], [1, "example-element-detail"], ["class", "w100 example-element-description py-1", 4, "ngIf"], [1, "w100", "example-element-description", "py-1"], [1, "im-card-no-border-table", "w-100"], [1, "w40"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], [1, "table", "table-striped", "w-100"], ["id", "expClientCol", 1, "common-bene-class-for-translation"], ["class", "border border-dark", 4, "ngFor", "ngForOf"], [1, "border", "border-dark"], [1, "circleIndex", "rounded-circle"], ["id", "listOfClientsLbl", 1, "common-bene-class-for-translation"], ["nowrap", "", 1, "common-bene-class-for-translation", 3, "id"], ["nowrap", ""], [1, "table", "table-striped", "w-100", "table-fixed"], [1, "w-half-minus-40px", "common-bene-class-for-translation", 3, "id"], [1, "w-half-minus-40px"], [1, "common-bene-class-for-translation", 2, "margin-left", "5px", 3, "id"], ["class", "w40", 4, "ngIf"], ["nowrap", "", "class", "common-bene-class-for-translation", 3, "id", 4, "ngIf"], ["nowrap", "", 4, "ngIf"], [3, "fileName", "Path"], ["mat-header-row", ""], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"], [1, "mat-row"], ["id", "noWorkExpText", "colspan", "3", 1, "mat-cell", "empty-cell", "noData"], [1, "errorMsg"], [1, "addDetails", 3, "click"], [1, "common-bene-class-for-translation", "pl-1", "pr-1"]], template: function GenericBeneficiaryWorkExperienceComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GenericBeneficiaryWorkExperienceComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showLifeStoryTimeLineSection);
    } }, directives: [i5.NgIf, i12.MatCard, i13.MatTable, i5.NgForOf, i13.MatColumnDef, i13.MatCellDef, i13.MatHeaderRowDef, i13.MatRowDef, i13.MatNoDataRow, i5.NgClass, i14.MatAccordion, i15.MatTabGroup, i15.MatTab, i15.MatTabLabel, i15.MatTabContent, i16.ɵangular_packages_forms_forms_ba, i16.NgControlStatusGroup, i16.NgForm, i16.NumberValueAccessor, i16.DefaultValueAccessor, i16.NgControlStatus, i16.NgModel, i17.MatDivider, i18.MatCheckbox, i19.Dropdown, i20.PrimeTemplate, i21.MatFormField, i22.MatInput, i23.MatDatepickerInput, i23.MatDatepickerToggle, i21.MatSuffix, i23.MatDatepicker, i16.PatternValidator, i16.MaxLengthValidator, i24.CustomQuestionnaireComponent, i25.MatList, i25.MatListSubheaderCssMatStyler, i25.MatListItem, i26.MatLine, i3.MatIcon, i4.MatTooltip, i29.MatChipList, i29.MatChipInput, i21.MatHint, i29.MatChip, i29.MatChipRemove, i30.FileUploadDeafultLibraryComponent, i13.MatHeaderCellDef, i13.MatHeaderCell, i13.MatCell, FileDownloadComponent, i13.MatHeaderRow, i13.MatRow], pipes: [ImgDateFormatPipe], styles: [".beneficiary-workexp-clients-box{width:100%}.beneficiary-workexp-clients-box .client-name{width:40vw}.beneficiary-workexp-clients-box .dynamic-client-controlgroup{margin-bottom:10px}.beneficiary-workexp-clients-box .flex-row{display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch}.beneficiary-workexp-clients-box .flex-vertical{display:flex;font-size:14px;flex-direction:column;padding-right:1.25em}.beneficiary-workexp-clients-box .action-group{display:inline-flex;flex-direction:row;justify-content:space-around;align-items:center;margin-top:.2em}.beneficiary-workexp-clients-box .action-group .btn{color:#fff;background-color:green;line-height:1.2;height:34px}.beneficiary-workexp-clients-box .action-group .add_circle{font-size:24px;margin-left:4px;color:grey;cursor:pointer}.beneficiary-workexp-clients-box .action-group .add_circle:hover{color:green}.beneficiary-workexp-clients-box .client-display-box{padding:0}.beneficiary-workexp-clients-box .client-display-box .mat-subheader-clients-added{font-size:20px;font-weight:700}.beneficiary-workexp-clients-box mat-list-item{border:1px solid #dadada;width:70%}.beneficiary-workexp-clients-box mat-list-item.duties-list{height:72px!important}.beneficiary-workexp-clients-box .clients-list-item-partition{flex:1;display:flex;margin-right:5px;width:calc(25% - 5px)}.beneficiary-workexp-clients-box .numberCircle{border-radius:50%;width:36px;height:36px;padding:5px;background:#b5d8ff;border:2px solid #666;color:#676868;text-align:center;font-size:22px Arial,sans-serif}.beneficiary-workexp-clients-box .evenBg{background-color:#f5f5f5}.beneficiary-workexp-clients-box .border-top-radius{border-top-left-radius:.6em;border-top-right-radius:.6em}.beneficiary-workexp-clients-box .border-bottom-radius{border-bottom-left-radius:.6em;border-bottom-right-radius:.6em}.beneficiary-workexp-clients-box .delete-client-entry{cursor:pointer}.beneficiary-workexp-clients-box .delete-client-entry:active,.beneficiary-workexp-clients-box .delete-client-entry:hover{color:red}.beneficiary-workexp-clients-box .alert-message,.beneficiary-workexp-clients-box .error-validation{font-size:12px;color:red}.beneficiary-workexp-clients-box .error-validation{padding-left:1.2em}.beneficiary-workexp-clients-box .mat-form-field{font-size:14px;width:100%}.list-of-tools-and-technologies .mat-chip-list-wrapper{padding-bottom:10px!important}.experience-list-table{margin-bottom:0;font-family:Source Sans Pro}.experience-list-table thead th{color:#a4a7b5;border-bottom:none;border-top:none;vertical-align:middle!important;font-size:14px;line-height:18px;font-weight:700;color:#4d4f5c;padding:4px 14px 0!important;border-right:1px solid #e1e1e1}.experience-list-table tbody{border-left:1px solid #e1e1e1}.experience-list-table tbody tr{border-right:1px solid #e1e1e1;border-bottom:1px solid #e1e1e1!important}.experience-list-table tbody tr .mat-cell:not(.empty-cell){border-left:1px solid #e1e1e1;font-size:14px;line-height:20px;color:#4d4f5c;padding:14px 0 0 14px!important;word-break:break-word}.experience-list-table tbody tr .mat-cell:not(.empty-cell).inner-table-with-nopadding{padding:0!important}.experience-list-table tbody tr .mat-cell:not(.empty-cell) span{width:100%;display:inline-block;padding-right:9px;word-break:break-word;margin-bottom:14px}.experience-list-table tbody tr .mat-cell:not(.empty-cell):last-child span{border:none}.experience-list-table tbody tr .mat-cell:not(.empty-cell).mat-column-fileLocation{text-align:center}table{width:100%}tr.example-detail-row{height:0}tr.example-element-row:not(.example-expanded-row):hover{background:#f5f5f5}tr.example-element-row:not(.example-expanded-row):active{background:#efefef}.example-element-row td{border-bottom-width:0}.example-element-detail{overflow:hidden}.example-element-diagram{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.example-element-symbol{font-weight:700;font-size:40px;line-height:normal}.example-element-description{padding:16px}.example-element-description li:nth-child(odd){background:#d3d3d3}.bgGray{background-color:#d3d3d3!important}.circleIndex{width:20px;height:20px;background-color:#8ecdd6;text-align:center}.w40{width:40px!important}.w200{width:200px!important}.w-half-minus-40px{width:calc((100% - 40px) / 2)}.icn{cursor:pointer}.spacing{margin:10px 0}.f10{font-size:12px;color:#afaaaa}.dasheedTopBorder{border-top:1px dashed grey}.paddingTop10{padding-top:10px}.formBox,.mTop10{margin-top:10px!important}.w100{width:100%!important}.title-steps{margin:10px 0;font-weight:700}.mLeft{margin-left:2rem}.viewType>.childBtn.firstBtn{border-right:.75px solid grey!important;border-left:none!important}.viewType>.childBtn.lastBtn{border-right:none!important;border-left:.75px solid grey!important}.mb-10{margin-bottom:10px}.add-placeholder .btn{padding:0 16px!important}.disabledView{pointer-events:none}.noData{color:#ef4747}.addDetails{cursor:pointer!important;color:#2196f3!important}.errorMsg{display:flex}"], encapsulation: 2, data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryWorkExperienceComponent, [{
        type: Component,
        args: [{
                selector: 'lib-generic-beneficiary-work-experience',
                templateUrl: `./generic-beneficiary-work-experience.component.html`,
                styleUrls: ['./generic-beneficiary-work-experience.component.scss'],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ]
            }]
    }], function () { return [{ type: i1$2.ReferenceLibraryService }, { type: i1$2.ReferenceLibraryService }, { type: i2$2.ToastrService }, { type: i0.ChangeDetectorRef }, { type: i3$1.ActivatedRoute }, { type: i1$1.MatDialog }, { type: i5$1.CacheCountryListService }, { type: i2$1.Store }, { type: DependentProfileDataService }, { type: i8.AppServicesLibraryService }, { type: GenericBeneficiaryWorkExperienceService }, { type: i10.DirtyFormGuard }]; }, { mode: [{
            type: Input
        }], showLifeStoryTimeLineSection: [{
            type: Input
        }], isViewMode: [{
            type: Input
        }], caseRequestShowDivs: [{
            type: Input
        }], benQuestShowDivs: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], isI140: [{
            type: Input
        }], isTimeLine: [{
            type: Input
        }], formDetails: [{
            type: Input
        }], documentType: [{
            type: Input
        }], item: [{
            type: ViewChild,
            args: ['item', { static: true }]
        }], benExpForm: [{
            type: ViewChild,
            args: ['benExpForm']
        }], familyId: [{
            type: Input
        }], customQuestionsComponent: [{
            type: ViewChild,
            args: [CustomQuestionnaireComponent]
        }], isWizard: [{
            type: Input
        }] }); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2$1.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["immigration-file-upload-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["mat-button", "", 1, "btnCustom", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'immigration-file-upload-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2$1.Store }]; }, null); })();

class ImmigrationFileUploadService {
    constructor(http) {
        this.http = http;
        this.uploaded$ = new BehaviorSubject({});
        this.deletedfile$ = new BehaviorSubject({});
    }
    genericUploadDocument(useCase, useCaseId, categoryName, entityId, fileCategory, otherName, payload, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        return this.http.post(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entityId}/fileCategory/${fileCategory}${appendUrl}${profileFamilyString}?petitionId=${petitionId}`, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericPassPortUploadDocument(useCase, useCaseId, categoryName, entityId, fileCategory, otherName, payload, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entityId}/fileCategory/${fileCategory}${appendUrl}${profileFamilyString}`, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericDeletePassportUploadDocument(useCase, useCaseId, categoryName, fileCategory, fileId, entityId, useEntityId, isEntityBasedDelete) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const fileIdTobePassed = (isEntityBasedDelete) ? '' : fileId;
        return this.http.delete(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}/fileCategory/${fileCategory}/${fileIdTobePassed}`).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericGetPassportUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map$1((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericGetPetitionUploadDocument(petitionId, caseType, categoryCode, fileCategoryCode, entityId, type, otherName, payload, familyId) {
        let profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        if (otherName) {
            profileFamilyString = profileFamilyString ? `${profileFamilyString}&otherName=${otherName}` : `?otherName=${otherName}`;
        }
        let url = `/document/category/fileCategory/${petitionId}/${categoryCode}/${fileCategoryCode}/${entityId}/${this.toEncrypt(type)}${profileFamilyString}`;
        if (caseType === 'I485' || type === 'PETITION') {
            url = `/document/category/fileCategory/${petitionId}/${categoryCode}/${fileCategoryCode}/${entityId}${profileFamilyString}`;
        }
        return this.http.post(url, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    generiBankUploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/upload/bankDetails/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericW4UploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/w4formsupload/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericForm16UploadDocument(categoryName, fileCategory, otherName, payload, empId, familyId) {
        let appendUrl = '';
        if (otherName) {
            appendUrl = `?otherName=${otherName}`;
        }
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.post(`/formBuilder/employee/form16upload/${empId}/category/${categoryName}/fileCategory/${fileCategory}`, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map$1((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericPetitionGetUploadDocument(petitionId, categoryCode) {
        return this.http.get(`/petition/getDocuments/${petitionId}/${categoryCode}`).pipe(map$1((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericPetitionGetUploadDocumentI130(gcVisaType, gcPermI140I130Id, categoryCode) {
        return this.http.get(`/gcCase/getDocuments/${gcVisaType}/${gcPermI140I130Id}/${categoryCode}`).pipe(map$1((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericBankGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/fbUploadedDocs/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map$1((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericW4GetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/fbW4UploadedDocs/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map$1((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
    genericDeleteUploadDocument(useCase, useCaseId, categoryName, fileCategory, fileId, entityId, useEntityId, isEntityBasedDelete) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const fileIdTobePassed = (isEntityBasedDelete) ? '' : fileId;
        return this.http.delete(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}/fileCategory/${fileCategory}/${fileIdTobePassed}`).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    genericPetitionDeleteUploadDocument(visaType, caseType, caseId, documentId) {
        return this.http.delete(`/${visaType}/${caseType}/${caseId}/document/${documentId}`).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    deleteBankFileFromDocumentList(empId) {
        return this.http.delete(`/formBuilder/employee/bankDetails/delete/${empId}`).pipe(map$1((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    deleteW4FileFromDocumentList(empId, categoryName, fileCategory) {
        return this.http.delete(`/formBuilder/employee/w4Details/delete/${empId}/category/${categoryName}/fileCategory/${fileCategory}`).pipe(map$1((data) => {
            this.deletefile(empId);
            return data;
        }));
    }
    getEntitySpecificUploadDocument(useCase, useCaseId, categoryName, entity) {
        // console.log(entity);
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}/entity/${entity}`).pipe(map$1((response) => response));
    }
    uploaded() {
        this.uploaded$.next(true);
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    /**
     * New API
     */
    immigrationDocumentUpload(gcPermOrI140Id, categoryCode, fileCategoryCode, entityId, type, payload) {
        return this.http.post(`/document/category/fileCategory/${gcPermOrI140Id}/${categoryCode}/${fileCategoryCode}/${entityId}/${this.toEncrypt(type)}`, payload).pipe(map$1((response) => {
            this.uploaded();
            return response;
        }));
    }
    immigrationGetDocumentUpload(gcVisaType, gcPermI140I130Id, categoryCode) {
        return this.http.get(`/gcCase/getDocuments/${gcVisaType}/${gcPermI140I130Id}/${categoryCode}`);
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
ImmigrationFileUploadService.ɵfac = function ImmigrationFileUploadService_Factory(t) { return new (t || ImmigrationFileUploadService)(i0.ɵɵinject(i1.HttpClient)); };
ImmigrationFileUploadService.ɵprov = i0.ɵɵdefineInjectable({ token: ImmigrationFileUploadService, factory: ImmigrationFileUploadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImmigrationFileUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_select_4_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", type_r15.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", type_r15.name, " ");
} }
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 15, 16);
    i0.ɵɵlistener("ngModelChange", function ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template_select_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(4); return ctx_r16.fileCategory = $event; })("change", function ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template_select_change_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(4); return ctx_r18.setOtherNameEmpty(); });
    i0.ɵɵelementStart(2, "option", 17);
    i0.ɵɵtext(3, "Select");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_select_4_option_4_Template, 2, 2, "option", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngModel", ctx_r11.fileCategory);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.documentTypes);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_input_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 20);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", ctx_r12.selectedDocType);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "label", 12);
    i0.ɵɵtext(3, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_select_4_Template, 5, 2, "select", 13);
    i0.ɵɵtemplate(5, ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_input_5_Template, 1, 1, "input", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r7.documentTypes == null ? null : ctx_r7.documentTypes.length) > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r7.documentTypes == null ? null : ctx_r7.documentTypes.length) == 1);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2, "Document Type Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 22);
    i0.ɵɵlistener("ngModelChange", function ImmigrationFileUploadComponent_ng_template_0_div_0_div_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.otherName = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r8.otherName);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "button", 23);
    i0.ɵɵlistener("filesChange", function ImmigrationFileUploadComponent_ng_template_0_div_0_div_4_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return ctx_r21.files = $event; });
    i0.ɵɵtext(3, " Browse ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 24);
    i0.ɵɵtext(5, "Max file size is 10 MB | PDF file type is allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r9.entityId === 0 || !ctx_r9.fileCategory || ctx_r9.family && !ctx_r9.familyId)("accept", ctx_r9.acceptFileType)("files", ctx_r9.files);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_5_mat_icon_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 29);
    i0.ɵɵtext(1, "upload_file");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "w-200": a0 }; };
function ImmigrationFileUploadComponent_ng_template_0_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 25);
    i0.ɵɵelementStart(2, "button", 26);
    i0.ɵɵlistener("filesChange", function ImmigrationFileUploadComponent_ng_template_0_div_0_div_5_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.files = $event; })("filesChange", function ImmigrationFileUploadComponent_ng_template_0_div_0_div_5_Template_button_filesChange_2_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(3); return ctx_r26.onFileSelected($event); });
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtemplate(5, ImmigrationFileUploadComponent_ng_template_0_div_0_div_5_mat_icon_5_Template, 2, 0, "mat-icon", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 24);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, ctx_r10.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r10.entityId === 0 || !ctx_r10.fileCategory || ctx_r10.inputMultipleFlag === null || ctx_r10.inputMultipleFlagFed === null || ctx_r10.inputMultipleFlagState === null || ctx_r10.family && !ctx_r10.familyId || ctx_r10.fileCategory === "OTHER" && ctx_r10.otherName.trim() === "")("accept", ctx_r10.acceptFileType)("files", ctx_r10.files);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r10.buttonOnlyMode);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.singleFileTypeName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r10.acceptedTypesText);
} }
const _c1 = function (a0) { return { "fileDahedBorderBox": a0 }; };
const _c2 = function (a0) { return { "marginTop": a0 }; };
function ImmigrationFileUploadComponent_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, ImmigrationFileUploadComponent_ng_template_0_div_0_div_1_Template, 6, 2, "div", 6);
    i0.ɵɵtemplate(2, ImmigrationFileUploadComponent_ng_template_0_div_0_div_2_Template, 4, 1, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, ImmigrationFileUploadComponent_ng_template_0_div_0_div_4_Template, 6, 3, "div", 9);
    i0.ɵɵtemplate(5, ImmigrationFileUploadComponent_ng_template_0_div_0_div_5_Template, 10, 9, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, !ctx_r2.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.documentTypeRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fileCategory === "OTHER");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2, !ctx_r2.buttonOnlyMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isMultiple);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isMultiple);
} }
function ImmigrationFileUploadComponent_ng_template_0_ngfFormData_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngfFormData", 30);
    i0.ɵɵlistener("FormDataChange", function ImmigrationFileUploadComponent_ng_template_0_ngfFormData_1_Template_ngfFormData_FormDataChange_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("files", ctx_r3.files)("FormData", ctx_r3.uploadedFilesData);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_2_tr_21_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngfBackground", item_r30);
} }
const _c3 = function () { return ["image/gif", "image/png", "image/jpeg"]; };
function ImmigrationFileUploadComponent_ng_template_0_div_2_tr_21_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtemplate(2, ImmigrationFileUploadComponent_ng_template_0_div_2_tr_21_div_2_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 38);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 38);
    i0.ɵɵelementStart(11, "div", 39);
    i0.ɵɵelementStart(12, "div", 40);
    i0.ɵɵelementStart(13, "span", 41);
    i0.ɵɵlistener("click", function ImmigrationFileUploadComponent_ng_template_0_div_2_tr_21_Template_span_click_13_listener() { i0.ɵɵrestoreView(_r35); const i_r31 = ctx.index; const ctx_r34 = i0.ɵɵnextContext(3); return ctx_r34.files.splice(i_r31, 1); });
    i0.ɵɵelement(14, "i", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(7, _c3).indexOf(item_r30.type) >= 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r30.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r30.type, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(9, 4, item_r30.size / 1024 / 1024, ".2"), " MB ");
} }
function ImmigrationFileUploadComponent_ng_template_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Files To Be Uploaded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32);
    i0.ɵɵelementStart(5, "div", 33);
    i0.ɵɵelementStart(6, "button", 34);
    i0.ɵɵlistener("click", function ImmigrationFileUploadComponent_ng_template_0_div_2_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.files.length = 0; });
    i0.ɵɵelement(7, "i", 35);
    i0.ɵɵtext(8, " Remove all ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "table", 36);
    i0.ɵɵelementStart(10, "thead");
    i0.ɵɵelementStart(11, "tr");
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵtext(13, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th");
    i0.ɵɵtext(15, "Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17, "Size");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "th");
    i0.ɵɵtext(19, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵtemplate(21, ImmigrationFileUploadComponent_ng_template_0_div_2_tr_21_Template, 15, 8, "tr", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "ngfFormData", 30);
    i0.ɵɵlistener("FormDataChange", function ImmigrationFileUploadComponent_ng_template_0_div_2_Template_ngfFormData_FormDataChange_22_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !ctx_r4.files.length);
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", ctx_r4.files);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("files", ctx_r4.files)("FormData", ctx_r4.uploadedFilesData);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 49);
    i0.ɵɵtext(1, " Actions ");
    i0.ɵɵelementEnd();
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 56);
    i0.ɵɵlistener("click", function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r50); const item_r41 = i0.ɵɵnextContext(3).$implicit; const ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.openDoc(item_r41); });
    i0.ɵɵelementStart(1, "mat-icon", 57);
    i0.ɵɵtext(2, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtemplate(1, ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_span_1_Template, 3, 0, "span", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r41.fileLocation);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelement(1, "file-download-library", 58);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", item_r41.fileLocationName)("Path", ctx_r45.envPath + item_r41.fileLocation.substring(23));
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelementStart(1, "span", 56);
    i0.ɵɵlistener("click", function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); const i_r42 = ctx_r54.index; const item_r41 = ctx_r54.$implicit; const ctx_r53 = i0.ɵɵnextContext(3); return ctx_r53.deleteFiles(i_r42, item_r41); });
    i0.ɵɵelementStart(2, "mat-icon", 59);
    i0.ɵɵtext(3, "delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 38);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵtemplate(2, ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_2_Template, 2, 1, "div", 53);
    i0.ɵɵtemplate(3, ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_3_Template, 2, 2, "div", 53);
    i0.ɵɵtemplate(4, ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_div_4_Template, 4, 0, "div", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = i0.ɵɵnextContext().$implicit;
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r43.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r41.fileLocation && ctx_r43.isDownloadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.isDeleteEnabled && false);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵelementStart(3, "a", 50);
    i0.ɵɵlistener("click", function ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r58); const item_r41 = ctx.$implicit; const ctx_r57 = i0.ɵɵnextContext(3); return ctx_r57.openDoc(item_r41); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 38);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 38);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_td_10_Template, 5, 3, "td", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = ctx.$implicit;
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r41.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r41.fileCategory.code === "OTHER" ? item_r41.fileCategoryOtherName ? item_r41.fileCategoryOtherName : item_r41.fileCategory.name : item_r41.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(9, 4, item_r41.fileSize / 1024 / 1024, ".2"), " MB");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r40.isViewEnabled || ctx_r40.isDownloadEnabled || ctx_r40.isDeleteEnabled);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "h5", 44);
    i0.ɵɵtext(2, "List of Uploaded Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table", 45);
    i0.ɵɵelementStart(4, "thead");
    i0.ɵɵelementStart(5, "tr");
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "Size");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, ImmigrationFileUploadComponent_ng_template_0_div_3_th_12_Template, 2, 0, "th", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "tbody", 47);
    i0.ɵɵtemplate(14, ImmigrationFileUploadComponent_ng_template_0_div_3_tr_14_Template, 11, 7, "tr", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngIf", ctx_r5.isViewEnabled || ctx_r5.isDownloadEnabled || ctx_r5.isDeleteEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.listFiles)("ngForTrackBy", ctx_r5.trackItem);
} }
function ImmigrationFileUploadComponent_ng_template_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2, "No Documents Uploaded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ImmigrationFileUploadComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ImmigrationFileUploadComponent_ng_template_0_div_0_Template, 6, 10, "div", 1);
    i0.ɵɵtemplate(1, ImmigrationFileUploadComponent_ng_template_0_ngfFormData_1_Template, 1, 2, "ngfFormData", 2);
    i0.ɵɵtemplate(2, ImmigrationFileUploadComponent_ng_template_0_div_2_Template, 23, 4, "div", 3);
    i0.ɵɵtemplate(3, ImmigrationFileUploadComponent_ng_template_0_div_3_Template, 15, 3, "div", 3);
    i0.ɵɵtemplate(4, ImmigrationFileUploadComponent_ng_template_0_div_4_Template, 3, 0, "div", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isUploadEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.family && ctx_r0.familyId == null && ctx_r0.isFileListRequired && ctx_r0.files && ctx_r0.files.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listFiles && ctx_r0.listFiles.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.listFiles || ctx_r0.listFiles && ctx_r0.listFiles.length === 0);
} }
function ImmigrationFileUploadComponent_ng_template_1_ngfFormData_0_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngfFormData", 30);
    i0.ɵɵlistener("FormDataChange", function ImmigrationFileUploadComponent_ng_template_1_ngfFormData_0_Template_ngfFormData_FormDataChange_0_listener($event) { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.uploadedFilesData = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("files", ctx_r59.files)("FormData", ctx_r59.uploadedFilesData);
} }
const _c4 = function (a0) { return { "disabled": a0 }; };
function ImmigrationFileUploadComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵelementStart(1, "button", 64);
    i0.ɵɵlistener("filesChange", function ImmigrationFileUploadComponent_ng_template_1_div_1_Template_button_filesChange_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(2); return ctx_r64.files = $event; })("filesChange", function ImmigrationFileUploadComponent_ng_template_1_div_1_Template_button_filesChange_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(2); return ctx_r66.onFileSelected($event); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 24);
    i0.ɵɵtext(4, "Max file size is 10 MB | PDF file type is allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4, ctx_r60.entityId === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r60.entityId === 0 || !ctx_r60.fileCategory)("accept", ctx_r60.acceptFileType)("files", ctx_r60.files);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r60.singleFileTypeName);
} }
function ImmigrationFileUploadComponent_ng_template_1_div_2_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 69);
    i0.ɵɵlistener("click", function ImmigrationFileUploadComponent_ng_template_1_div_2_mat_icon_4_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(3); return ctx_r68.deleteFiles(0, ctx_r68.listFiles[0]); });
    i0.ɵɵtext(1, "delete");
    i0.ɵɵelementEnd();
} }
function ImmigrationFileUploadComponent_ng_template_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "span", 66);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "file-download-library", 67);
    i0.ɵɵtemplate(4, ImmigrationFileUploadComponent_ng_template_1_div_2_mat_icon_4_Template, 2, 0, "mat-icon", 68);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r61.listFiles[0].fileNameWithExtension);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fileName", ctx_r61.listFiles[0].fileLocation.substring(23))("Path", ctx_r61.envPath + ctx_r61.listFiles[0].fileLocation.substring(23));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", false);
} }
function ImmigrationFileUploadComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ImmigrationFileUploadComponent_ng_template_1_ngfFormData_0_Template, 1, 2, "ngfFormData", 2);
    i0.ɵɵtemplate(1, ImmigrationFileUploadComponent_ng_template_1_div_1_Template, 5, 7, "div", 61);
    i0.ɵɵtemplate(2, ImmigrationFileUploadComponent_ng_template_1_div_2_Template, 5, 4, "div", 62);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.isViewEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.listFiles || ctx_r1.listFiles && ctx_r1.listFiles.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.listFiles && ctx_r1.listFiles.length > 0);
} }
class ImmigrationFileUploadComponent {
    constructor(uploadDocumentService, toastr, dialog, changeDetectorRef, referenceLibraryService) {
        this.uploadDocumentService = uploadDocumentService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.changeDetectorRef = changeDetectorRef;
        this.referenceLibraryService = referenceLibraryService;
        this.fileUploadSuccess = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.documentTypes = [];
        this.files = [];
        this.listFiles = [];
        this.categoryName = 'BENEDUDOC';
        this.displayedColumns = ['name', 'documentType', 'size'];
        this.dataSource = [];
        this.fileCategory = '';
        this.otherName = '';
        this.showSpecify = false;
        this.useEntityId = false;
        this.isEntityBasedDelete = false;
        this.selectedDocType = '';
        this.isViewEnabled = true;
        this.isDownloadEnabled = true;
        this.isDeleteEnabled = true;
        this.isUploadEnabled = true; // IM 3926
        this.subcriptions = [];
        this.acceptedTypesText = acceptedFileTypesText;
        this.files = [];
        this.isMultiple = false;
        this.acceptFileType = acceptedFileTypes; // Acceptable types: application/pdf, image/*
        this.isFileListRequired = true;
        this.documentTypeRequired = false;
        this.docummentTypeCode = null;
        this.useCase = '';
        this.useCaseId = 0;
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    }
    ngOnInit() {
        this.envPath = environment.docs;
    }
    ngOnChanges(e) {
        if (e.configurations && e.configurations.currentValue) {
            this.isMultiple = false;
            this.singleFileTypeName = e.configurations.currentValue.singleFileTypeName ? e.configurations.currentValue.singleFileTypeName : 'Browse';
            this.buttonOnlyMode = e.configurations.currentValue.buttonOnlyMode ? e.configurations.currentValue.buttonOnlyMode : false;
            this.acceptFileType = e.configurations.currentValue.fileType;
            this.isFileListRequired = e.configurations.currentValue.isFileListRequired;
            this.categoryName = e.configurations.currentValue.categoryName;
            this.entityId = e.configurations.currentValue.entityId;
            this.inputMultipleFlag = e.configurations.currentValue.inputMultipleFlag;
            this.inputMultipleFlagState = e.configurations.currentValue.inputMultipleFlagState;
            this.inputMultipleFlagFed = e.configurations.currentValue.inputMultipleFlagFed;
            this.fileCategory = e.configurations.currentValue.fileCategory;
            this.listFiles = e.configurations.currentValue.listUploadedFiles ?
                e.configurations.currentValue.entityType ?
                    e.configurations.currentValue.listUploadedFiles.filter(x => x[e.configurations.currentValue.entityType] == this.entityId) :
                    e.configurations.currentValue.listUploadedFiles.filter(x => x.entityId == this.entityId) : [];
            this.documentTypeRequired = e.configurations.currentValue.documentTypeRequired;
            this.docummentTypeCode = e.configurations.currentValue.docummentTypeCode;
            this.useCase = e.configurations.currentValue.useCase;
            this.useCaseId = e.configurations.currentValue.useCaseId;
            this.useEntityId = (e.configurations.currentValue.useEntityId) ? e.configurations.currentValue.useEntityId : false;
            this.isEntityBasedDelete = (e.configurations.currentValue.isEntityBasedDelete) ?
                e.configurations.currentValue.isEntityBasedDelete : false;
            this.isViewEnabled = (e.configurations.currentValue.isViewEnabled === false) ? false : true;
            this.isDownloadEnabled = (e.configurations.currentValue.isDownloadEnabled === false) ? false : true;
            this.listFiles = this.listFiles.map((_e) => {
                _e.fileLocationName = (this.isFBUser && _e.fileLocation) ? _e.fileLocation.split('/').slice(-1)[0] : _e.fileLocation.substring(23);
                return _e;
            });
            this.isDeleteEnabled = (e.configurations.currentValue.isDeleteEnabled === false) ? false : true;
            this.isUploadEnabled = (e.configurations.currentValue.isUploadEnabled === false) ? false : true;
            this.petitionOutcomeId = e.configurations.currentValue.petitionOutcomeId ? e.configurations.currentValue.petitionOutcomeId : null;
            this.singleButtonUpload = e.configurations.currentValue.singleButtonUpload ? e.configurations.currentValue.singleButtonUpload : false;
            this.familyId = e.configurations.currentValue.familyId ? e.configurations.currentValue.familyId : null;
            this.family = e.configurations.currentValue.family ? e.configurations.currentValue.family : false;
            if (this.docummentTypeCode) {
                if (this.documentTypeRequired) {
                    this.fileCategory = '';
                }
                this.getDocumentTypeList();
            }
            // Refresh the To be uploaded files list
            if (this.fileCategory === '') {
                this.files = [];
            }
        }
        if (e.primaryData && e.primaryData.currentValue) {
            this.inputData = e.primaryData.currentValue;
        }
    }
    getDocumentTypeList() {
        this.subcriptions[this.subcriptions.length] =
            this.referenceLibraryService.getReferenceDataWithoutAuthentication(this.docummentTypeCode)
                .subscribe((response) => {
                if (this.petitionOutcomeId) {
                    switch (this.petitionOutcomeId) {
                        case 'APPROVED':
                            this.documentTypes = response.filter(x => x.code === 'APPROVAL');
                            break;
                        case 'RFE':
                            this.documentTypes = response.filter(x => x.code === 'RFE');
                            break;
                        case 'NOID':
                            this.documentTypes = response.filter(x => x.code === 'NOID');
                            break;
                        case 'DENIED':
                            this.documentTypes = response.filter(x => x.code === 'DENIAL');
                            break;
                        case 'PETWITHDRAW':
                            this.documentTypes = response.filter(x => x.code === 'WITHDRWACK' || x.code === 'WITHDRAW');
                            break;
                        case 'GET_RECEIPT':
                            this.documentTypes = response.filter(x => x.code === 'RECNOTC');
                            break;
                        default:
                            this.documentTypes = response;
                            break;
                    }
                }
                else {
                    this.documentTypes = response;
                }
                if (this.documentTypes && this.documentTypes.length === 1) {
                    this.fileCategory = this.documentTypes[0].code;
                    this.selectedDocType = this.documentTypes[0].name;
                }
                else {
                    this.selectedDocType = '';
                }
            });
    }
    uploadFiles() {
        if (this.documentTypeRequired) {
            if (this.fileCategory) {
                if (this.files[this.files.length - 1].size <= 10485760) {
                    if (this.categoryName === 'BANKDETAILSDOC' || this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE' || this.categoryName === 'FORM16DETAILSDOC') {
                        this.uploadFinancials();
                    }
                    else if (this.categoryName !== 'BENGREENCARD') {
                        this.uploadDocument();
                    }
                    else {
                        if (this.family && this.familyId == null) {
                        }
                        else {
                            this.uploadDocument();
                        }
                    }
                }
                else {
                    this.files = [];
                    CustomErrorToastComponent.showErrorToast(this.toastr, 'File Size is > 10MB');
                }
            }
            else {
                this.files = [];
                CustomErrorToastComponent.showErrorToast(this.toastr, 'Select a document type');
            }
        }
        else {
            if (this.files[this.files.length - 1].size <= 10485760) {
                this.uploadDocument();
            }
            else {
                this.files = [];
                CustomErrorToastComponent.showErrorToast(this.toastr, 'File Size is > 10MB');
            }
        }
    }
    uploadDocument() {
        if (this.categoryName === 'BENEDUDOC' || this.categoryName === 'BENTRGDOC' || this.categoryName === 'BENLICDOC') {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.immigrationDocumentUpload(this.primaryData.i140CaseId, this.categoryName, this.fileCategory, this.entityId, this.primaryData.caseType, this.uploadedFilesData)
                .subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.immigrationGetDocumentUpload(this.primaryData.caseType, this.primaryData.i140CaseId, this.categoryName)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else if (this.categoryName === 'BENPASSDOC' || this.categoryName === 'BENGREENCARD') {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPassPortUploadDocument('beneficiary', this.useCaseId, this.categoryName, this.entityId, this.fileCategory, this.otherName, this.uploadedFilesData, this.primaryData.familyId)
                .subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPassportUploadDocument('beneficiary', this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.primaryData.familyId)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    // this.toastr.error(response['message']);
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else if (this.inputData.caseType == 'I130' && this.categoryName === 'BENWEDOC') {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPetitionUploadDocument(this.inputData.caseId, this.inputData.caseType, this.categoryName, this.fileCategory, this.entityId, this.primaryData.caseType, this.otherName, this.uploadedFilesData, this.primaryData.familyId).subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    let getURL = this.uploadDocumentService.genericPetitionGetUploadDocument(this.inputData.caseId, this.categoryName);
                    if (this.categoryName == 'BENWEDOC') {
                        getURL = this.uploadDocumentService.genericPetitionGetUploadDocumentI130(this.inputData.caseType || this.inputData.casetype, this.inputData.caseId, this.categoryName);
                    }
                    this.subcriptions[this.subcriptions.length] = getURL.subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
        else {
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPetitionUploadDocument(this.inputData.caseId, this.inputData.caseType, this.categoryName, this.fileCategory, this.entityId, this.primaryData.caseType, this.otherName, this.uploadedFilesData, this.primaryData.familyId).subscribe(response => {
                if (response.status === 200) {
                    this.fileUploadSuccess.emit();
                    this.toastr.success(response.message, 'Success');
                    this.files = [];
                    //setting Document Type Name(Other field) empty
                    this.setOtherNameEmpty();
                    // if the html have dropdown for selecting the catagory only we clear the fileCategory
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPetitionGetUploadDocument(this.inputData.caseId, this.categoryName)
                        .subscribe((responseGetUploadDocument) => {
                        if (responseGetUploadDocument.status === 200) {
                            this.listFiles =
                                responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                    .map(x => {
                                    return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                });
                            // Bcz entity Id is sometime alphanumeric
                            // this code was added for only LCA Withdrawn
                            if (this.fileCategory === 'LCAWTDOC') {
                                this.listFiles = this.listFiles.filter(x => x.fileCategory.code === this.fileCategory).map(e => {
                                    e.fileLocationName = (this.isFBUser && e.fileLocation) ? e.fileLocation.split('/').slice(-1)[0] : e.fileLocation.substring(23);
                                    return e;
                                });
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                        if (responseGetUploadDocument.status === 204) {
                            this.listFiles = [];
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                else {
                    if (this.documentTypeRequired && !this.selectedDocType) {
                        this.fileCategory = '';
                    }
                    this.files = [];
                }
            });
        }
    }
    uploadFinancials() {
        if (this.categoryName === 'BANKDETAILSDOC') {
            this.uploadDocumentService.generiBankUploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleBankUploadResponse(response));
        }
        else if (this.categoryName === 'FORM16DETAILSDOC') {
            this.uploadDocumentService.genericForm16UploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleW4UploadResponse(response));
        }
        else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
            this.uploadDocumentService.genericW4UploadDocument(this.categoryName, this.fileCategory, this.otherName, this.uploadedFilesData, this.configurations.entityId, this.familyId)
                .subscribe(response => this.handleW4UploadResponse(response));
        }
    }
    handleBankUploadResponse(response) {
        if (response.status === 200) {
            this.fileUploadSuccess.emit();
            this.toastr.success(response.message, 'Success');
            this.inputMultipleFlag = null;
            this.files = [];
            // Setting Document Type Name(Other field) empty
            this.setOtherNameEmpty();
            // If the HTML has dropdown for selecting the category only, clear the fileCategory
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericBankGetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles =
                        responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                            .map(x => {
                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                        });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
        else {
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.files = [];
        }
    }
    handleW4UploadResponse(response) {
        if (response.status === 200) {
            this.fileUploadSuccess.emit();
            this.toastr.success(response.message, 'Success');
            this.inputMultipleFlagState = null;
            this.inputMultipleFlagFed = null;
            this.files = [];
            // Setting Document Type Name(Other field) empty
            this.setOtherNameEmpty();
            // If the HTML has dropdown for selecting the category only, clear the fileCategory
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericW4GetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles =
                        responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                            .map(x => {
                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                        });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.changeDetectorRef.detectChanges();
                }
            });
        }
        else {
            if (this.documentTypeRequired && !this.selectedDocType) {
                this.fileCategory = '';
            }
            this.files = [];
        }
    }
    deleteFiles(index, item) {
        const title = 'Confirm Deletion!';
        const message = 'Do you want to delete this record?';
        if (this.categoryName === 'BENIMMDOC') {
            this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
                if (result) {
                    if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericDeleteUploadDocument(this.useCase, this.useCaseId, item.fileCategory.group, item.fileCategory.code, item.id, this.entityId, this.useEntityId, this.isEntityBasedDelete)
                            .subscribe((response) => {
                            if (response.status === 200) {
                                this.fileUploadSuccess.emit();
                                this.toastr.success(response.message, 'Success');
                                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.familyId)
                                    .subscribe((responseGetUploadDocument) => {
                                    if (responseGetUploadDocument.status === 200) {
                                        this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                            .map(x => {
                                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                        });
                                        this.changeDetectorRef.detectChanges();
                                    }
                                    if (responseGetUploadDocument.status === 204) {
                                        this.listFiles = [];
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                            }
                        });
                    }
                    if (this.categoryName === 'BANKDETAILSDOC') {
                        this.deleteBankDocumentHandler(item);
                    }
                    else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                        this.deleteW4DocumentHandler(item);
                    }
                }
            });
        }
        else if (this.categoryName === 'BENPASSDOC' || this.categoryName === 'BENGREENCARD') {
            const title = 'Confirm';
            const message = 'Do you wish to Delete the File?';
            this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
                if (result) {
                    if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericDeletePassportUploadDocument('beneficiary', this.useCaseId, item.fileCategory.group, item.fileCategory.code, item.id, this.entityId, this.useEntityId, this.isEntityBasedDelete)
                            .subscribe((response) => {
                            if (response.status === 200) {
                                this.fileUploadSuccess.emit();
                                this.toastr.success(response.message, 'Success');
                                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericGetPassportUploadDocument(this.useCase, this.useCaseId, this.categoryName, this.entityId, this.useEntityId, this.familyId)
                                    .subscribe((responseGetUploadDocument) => {
                                    if (responseGetUploadDocument.status === 200) {
                                        this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                            .map(x => {
                                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                        });
                                        this.changeDetectorRef.detectChanges();
                                    }
                                    if (responseGetUploadDocument.status === 204) {
                                        this.listFiles = [];
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                            }
                        });
                    }
                    if (this.categoryName === 'BANKDETAILSDOC') {
                        this.deleteBankDocumentHandler(item);
                    }
                    else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                        this.deleteW4DocumentHandler(item);
                    }
                }
            });
        }
        else {
            this.dialogueInitializer(title, message).afterClosed().subscribe(result => {
                if (result) {
                    if (this.categoryName !== 'BANKDETAILSDOC' && this.categoryName !== 'W4FORMS' && this.categoryName !== 'W4FORMSSTATE') {
                        this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPetitionDeleteUploadDocument(this.inputData.visaType || this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, item.id)
                            .subscribe((response) => {
                            if (response.status === 200) {
                                this.fileUploadSuccess.emit();
                                this.toastr.success(response.message, 'Success');
                                this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericPetitionGetUploadDocument(this.inputData.caseId, this.categoryName)
                                    .subscribe((responseGetUploadDocument) => {
                                    if (responseGetUploadDocument.status === 200) {
                                        this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                                            .map(x => {
                                            return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                                        });
                                        this.changeDetectorRef.detectChanges();
                                    }
                                    if (responseGetUploadDocument.status === 204) {
                                        this.listFiles = [];
                                        this.changeDetectorRef.detectChanges();
                                    }
                                });
                            }
                            else {
                                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
                            }
                        });
                    }
                    if (this.categoryName === 'BANKDETAILSDOC') {
                        this.deleteBankDocumentHandler(item);
                    }
                    else if (this.categoryName === 'W4FORMS' || this.categoryName === 'W4FORMSSTATE') {
                        this.deleteW4DocumentHandler(item);
                    }
                }
            });
        }
    }
    openDoc(item) {
        const docPath = item.fileLocation.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    trackItem(index, item) {
        return item.id;
    }
    dialogueInitializer(title, message) {
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '40%',
            data: {
                update: { title, message },
                buttons: ['No', 'Yes']
            }
        });
        return dialogRef;
    }
    deleteBankDocumentHandler(item) {
        this.uploadDocumentService.deleteBankFileFromDocumentList(this.configurations.entityId).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.toastr.success(data.message, 'Success');
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericBankGetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                        .map(x => {
                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                    });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    this.inputMultipleFlag = true;
                    this.changeDetectorRef.detectChanges();
                }
            });
        });
    }
    deleteW4DocumentHandler(item) {
        this.uploadDocumentService.deleteW4FileFromDocumentList(this.configurations.entityId, this.categoryName, this.fileCategory).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.toastr.success(data.message, 'Success');
            this.subcriptions[this.subcriptions.length] = this.uploadDocumentService.genericW4GetUploadDocument(this.useCase, this.configurations.entityId, this.categoryName, this.configurations.entityId, this.useEntityId, this.familyId)
                .subscribe((responseGetUploadDocument) => {
                if (responseGetUploadDocument.status === 200) {
                    this.listFiles = responseGetUploadDocument.data.filter(x => x.entityId == this.entityId && x.fileLocation !== null)
                        .map(x => {
                        return Object.assign(Object.assign({}, x), { fileNameWithExtension: x.fileLocation.replace(/^.*[\\\/]/, ''), fileLocationName: (this.isFBUser && x.fileLocation) ? x.fileLocation.split('/').slice(-1)[0] : x.fileLocation.substring(23) });
                    });
                    this.changeDetectorRef.detectChanges();
                }
                if (responseGetUploadDocument.status === 204) {
                    this.listFiles = [];
                    if (this.categoryName === 'W4FORMS') {
                        this.inputMultipleFlagFed = true;
                    }
                    else if (this.categoryName === 'W4FORMSSTATE') {
                        this.inputMultipleFlagState = true;
                    }
                    this.changeDetectorRef.detectChanges();
                }
            });
        });
    }
    onFileSelected(e) {
        if (e && e.length > 0) {
            setTimeout(() => {
                this.uploadFiles();
            }, 500);
        }
    }
    setOtherNameEmpty() {
        this.otherName = '';
    }
    ngOnDestroy() {
        this.subcriptions.forEach(subscription => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }
}
ImmigrationFileUploadComponent.ɵfac = function ImmigrationFileUploadComponent_Factory(t) { return new (t || ImmigrationFileUploadComponent)(i0.ɵɵdirectiveInject(ImmigrationFileUploadService), i0.ɵɵdirectiveInject(i2$2.ToastrService), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.ReferenceLibraryService)); };
ImmigrationFileUploadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ImmigrationFileUploadComponent, selectors: [["immigration-file-upload"]], inputs: { configurations: "configurations", primaryData: "primaryData" }, outputs: { fileUploadSuccess: "fileUploadSuccess" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "ngIf"], ["class", "row", 3, "ngClass", 4, "ngIf"], ["postName", "file", 3, "files", "FormData", "FormDataChange", 4, "ngIf"], ["class", "pt-2 marginBottom", 4, "ngIf"], ["class", "pt-2 text-center marginBottom", 4, "ngIf"], [1, "row", 3, "ngClass"], ["class", "col-4 mt-1", 4, "ngIf"], ["class", "col-4 form-group", 4, "ngIf"], [1, "col-4", 3, "ngClass"], [4, "ngIf"], [1, "col-4", "mt-1"], [1, "form-group"], [1, "label-cls", "d-block"], ["class", "im-input mt-2 mw-100 d-block", "name", "fileCategoryType", "required", "", 3, "ngModel", "ngModelChange", "change", 4, "ngIf"], ["type", "text", "class", "im-input mt-2 mw-100 d-block", "readonly", "", 3, "value", 4, "ngIf"], ["name", "fileCategoryType", "required", "", 1, "im-input", "mt-2", "mw-100", "d-block", 3, "ngModel", "ngModelChange", "change"], ["fileCategoryType", "ngModel"], ["value", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["type", "text", "readonly", "", 1, "im-input", "mt-2", "mw-100", "d-block", 3, "value"], [1, "col-4", "form-group"], ["type", "text", 1, "im-input", 3, "ngModel", "ngModelChange"], ["type", "button", "multiple", "1", "ngfSelect", "", 1, "im-btn", "im-btn-md", "im-btn-primary", 3, "disabled", "accept", "files", "filesChange"], [1, "label-cls", "single-file-upload", "d-block"], [1, "form-group", "mb-0", 3, "ngClass"], ["type", "button", "ngfSelect", "", 1, "btn-primary", "im-btn-md", "im-btn-primary", 3, "disabled", "accept", "files", "filesChange"], [1, "btnModeBtnContent"], ["class", "material-icons", 4, "ngIf"], [1, "material-icons"], ["postName", "file", 3, "files", "FormData", "FormDataChange"], [1, "pt-2", "marginBottom"], [1, "d-flex", "flex-row-reverse"], [1, "p-2"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-sm", 3, "disabled", "click"], ["aria-hidden", "true", 1, "fa", "fa-trash"], [1, "im-card-no-border-table"], [4, "ngFor", "ngForOf"], ["nowrap", ""], [1, "d-flex", "flex-row"], [1, "p-2", "padding0"], ["title", "Remove", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-trash", "fa-lg", "icn"], [1, "previewIcon", 3, "ngfBackground"], [1, "heading"], [1, "im-card-no-border-table", "file-upload-list", "table-striped-simple"], ["class", "text-center", 4, "ngIf"], [1, "wrap-word"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "text-center"], [1, "cursorPointer", 3, "click"], ["nowrap", "", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-center", "justify-content-center"], ["class", "mr-2 padding0", 4, "ngIf"], [1, "mr-2", "padding0"], [3, "click", 4, "ngIf"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons"], [3, "fileName", "Path"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Delete Document", 1, "material-icons"], [1, "pt-2", "text-center", "marginBottom"], ["class", "d-inline-block", 3, "ngClass", 4, "ngIf"], ["class", "d-inline-block", "class", "single-fileuploaded-view-holder", 4, "ngIf"], [1, "d-inline-block", 3, "ngClass"], ["type", "button", "matTooltipClass", "tooltip-bg", "ngfSelect", "", 1, "btn", "btn-outline-primary", "single-file-upload", 3, "disabled", "accept", "files", "filesChange"], [1, "single-fileuploaded-view-holder"], [1, "file-uploaded"], [1, "ml-3", "pr-2", 3, "fileName", "Path"], ["class", "mr-1 icn", "matTooltip", "Delete Document", "matTooltipClass", "tooltip-bg", "class", "material-icons", 3, "click", 4, "ngIf"], ["matTooltip", "Delete Document", "matTooltipClass", "tooltip-bg", 1, "material-icons", 3, "click"]], template: function ImmigrationFileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ImmigrationFileUploadComponent_ng_template_0_Template, 5, 5, "ng-template", 0);
        i0.ɵɵtemplate(1, ImmigrationFileUploadComponent_ng_template_1_Template, 3, 3, "ng-template", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.singleButtonUpload);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.singleButtonUpload);
    } }, directives: [i5.NgIf, i5.NgClass, i16.SelectControlValueAccessor, i16.RequiredValidator, i16.NgControlStatus, i16.NgModel, i16.NgSelectOption, i16.ɵangular_packages_forms_forms_z, i5.NgForOf, i16.DefaultValueAccessor, i7.ngfSelect, i3.MatIcon, i7.ngfFormData, i7.ngfBackground, i4.MatTooltip, i10$1.FileDownloadLibraryComponent], pipes: [i5.DecimalPipe], styles: [".marginTop[_ngcontent-%COMP%]{padding:30px 10px}.fileDahedBorderBox[_ngcontent-%COMP%]{border:1px dashed #d3d3d3;margin-bottom:10px}.padding0[_ngcontent-%COMP%]{padding:0!important}.file-upload-list[_ngcontent-%COMP%]{width:100%}.w-200[_ngcontent-%COMP%]{width:200px!important}.btnModeBtnContent[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:center;align-items:center}.file-upload-list[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{height:50px!important;text-transform:uppercase!important}.wrap-word[_ngcontent-%COMP%]{word-break:break-all}.marginBottom[_ngcontent-%COMP%]{margin-bottom:40px}.cursorPointer[_ngcontent-%COMP%]{cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImmigrationFileUploadComponent, [{
        type: Component,
        args: [{
                selector: 'immigration-file-upload',
                templateUrl: './immigration-file-upload.component.html',
                styleUrls: ['./immigration-file-upload.scss']
            }]
    }], function () { return [{ type: ImmigrationFileUploadService }, { type: i2$2.ToastrService }, { type: i1$1.MatDialog }, { type: i0.ChangeDetectorRef }, { type: i1$2.ReferenceLibraryService }]; }, { configurations: [{
            type: Input
        }], fileUploadSuccess: [{
            type: Output
        }], primaryData: [{
            type: Input
        }] }); })();

const routes = [
    {
        path: '',
        component: GenericBeneficiaryWorkExperienceComponent
    }
];
class GenericBeneficiaryWorkExperienceModule {
}
GenericBeneficiaryWorkExperienceModule.ɵfac = function GenericBeneficiaryWorkExperienceModule_Factory(t) { return new (t || GenericBeneficiaryWorkExperienceModule)(); };
GenericBeneficiaryWorkExperienceModule.ɵmod = i0.ɵɵdefineNgModule({ type: GenericBeneficiaryWorkExperienceModule });
GenericBeneficiaryWorkExperienceModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            ImageCropperModule,
            MatIconModule,
            DropdownModule,
            DialogModule,
            ButtonModule,
            PaginatorModule,
            MultiSelectModule,
            InputTextareaModule,
            MatExpansionModule,
            ConfirmDialogModule,
            AccordionModule,
            MatDatepickerModule,
            DeleteDialogLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatRadioModule,
            MatSelectModule,
            MatChipsModule,
            MatTableModule,
            MatPaginatorModule,
            MatTabsModule,
            MatTooltipModule,
            SaveAsDraftModule,
            FileUploadLibraryModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            HelpVideoOverlayLibraryModule,
            CustomQuestionnaireModule,
            ngfModule,
            RouterModule.forChild(routes)
        ], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GenericBeneficiaryWorkExperienceModule, { declarations: [GenericBeneficiaryWorkExperienceComponent, ImgDateFormatPipe, FileDownloadComponent, ImmigrationFileUploadComponent], imports: [PrimengLibraryModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        ImageCropperModule,
        MatIconModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        PaginatorModule,
        MultiSelectModule,
        InputTextareaModule,
        MatExpansionModule,
        ConfirmDialogModule,
        AccordionModule,
        MatDatepickerModule,
        DeleteDialogLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSelectModule,
        MatChipsModule,
        MatTableModule,
        MatPaginatorModule,
        MatTabsModule,
        MatTooltipModule,
        SaveAsDraftModule,
        FileUploadLibraryModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        HelpVideoOverlayLibraryModule,
        CustomQuestionnaireModule,
        ngfModule, i3$1.RouterModule], exports: [GenericBeneficiaryWorkExperienceComponent,
        ImmigrationFileUploadComponent,
        RouterModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericBeneficiaryWorkExperienceModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    GenericBeneficiaryWorkExperienceComponent, ImgDateFormatPipe, FileDownloadComponent, ImmigrationFileUploadComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    ImageCropperModule,
                    MatIconModule,
                    DropdownModule,
                    DialogModule,
                    ButtonModule,
                    PaginatorModule,
                    MultiSelectModule,
                    InputTextareaModule,
                    MatExpansionModule,
                    ConfirmDialogModule,
                    AccordionModule,
                    MatDatepickerModule,
                    DeleteDialogLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatChipsModule,
                    MatTableModule,
                    MatPaginatorModule,
                    MatTabsModule,
                    MatTooltipModule,
                    SaveAsDraftModule,
                    FileUploadLibraryModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    HelpVideoOverlayLibraryModule,
                    CustomQuestionnaireModule,
                    ngfModule,
                    RouterModule.forChild(routes)
                ],
                exports: [
                    GenericBeneficiaryWorkExperienceComponent,
                    ImmigrationFileUploadComponent,
                    RouterModule
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of generic-beneficiary-work-experience
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GenericBeneficiaryWorkExperienceComponent, GenericBeneficiaryWorkExperienceModule, GenericBeneficiaryWorkExperienceService, ImmigrationFileUploadComponent };
//# sourceMappingURL=generic-beneficiary-work-experience.js.map
